mainApp.directive('networkTopology', ['$timeout', '$filter', '$interval', '$state', '$rootScope', 'LinksProcessingService', 'DevicesService', 'GeneralUtilsService', 'EntityTypesService', 'SiteService', 'TimeZoneService', 'IntervalService', function ($timeout, $filter, $interval, $state, $rootScope, LinksProcessingService, DevicesService, GeneralUtilsService, EntityTypesService, SiteService, TimeZoneService, IntervalService) {
	return {
		templateUrl: '/public/directives/charts/networkTopology.html',
		scope: {},
		controller: function ($scope) {
			/**
			 * callback after disable response received, updating
			 * the stored db data and if the current object displayed hasn't
			 * change updating the status of the object
			 **/
			$scope.disableSiteCallback = function (object) {
				if (object.rootType == 'site' || object.rootType == 'login') {
					updateData.dbData[object.protoId].status = object.status;
					if ($scope.currentObject.protoId == object.protoId) { $scope.currentObject.status = object.status; }
				}
			};


			$scope.loaded = true;
			$scope.$root.dividedInner = true;
			$scope.states = {};
			$scope.isSystemLogin = isSystemLogin;

			showLoader();
			$timeout(function () {
				showLoader();
			}, 10, false);

			var timeouts = {
				updateTimeout: null,
				refreshNodesTimeout: null,
				updateLastUpdateTimeout: null,
				preventNodeDblClick: null,
				processNodesTimeout: null,
				implementTimeout: null,
				realtimeDataTimeout: null,
				realtimeExtendedTimeout: null,
				getTrafficTimeout: null,
				getAppsTimeout: null,
			};

			$scope.loaders = {
				links: false,
				traffic: false,
				apps: false,
				hosts: false,
			};

			var pops = [],
				treeData,
				rgraph;
			var updateData = {
				dbData: {},
				counters: {},
			};

			var containerEl = document.getElementById('infovis');

			let showFlags = false;

			var popIds = [],
				requiredPops = [],
				popsStashedForGrouping = [],
				updateCounter = 0,
				lastUpdated,
				noDataCounter = 0,
				scale = 1;

			var DB_FETCH_INTERVAL = 10,
				DEFAULT_POP_NAME = 'Cato',
				ONLINE_COLOR = 'white',
				MIN_TRAFFIC_COLOR = '#808080',
				MIN_NODES = 6,
				POP_SIZE = 10,
				SITE_SIZE = 20,
				LOGIN_SIZE = 18,
				TEST_MANY_USERS = false,// for dev, used for testing many users
				STATS_LAST_TIMESPAN = 1000 * 60 * 60 * 24, // 24 hours
				MIN_STATS_INTERVAL = 5 * 60 * 1000,
				RT_STATS_INTERVALS_COUNT = 24,
				MIN_NODES_COUNT_FOR_DISTANCEMODE = 12;


			var NUMBER_OF_SEGMENTS = 60;

			var min_users_to_group = 1000;

			var LABELS_LIMITS = {
				rightTop: Math.PI / 4,
				rightBottom: Math.PI / 1.25,
				bottom: Math.PI,
				left: Math.PI * 1.5,
				leftTop: Math.PI * 2,
				middle: 180 / Math.PI,
			};

			var foundAccount = false,
				implemented = false,
				lockNode = false,
				refreshPops = false,
				wheelMode = false;


			var appsPieChart,
				windowResize,
				handleVisibilityChange;

			var loginsGroupId = 'Logins_Group';

			var bladesConfirmOpen = false;
			var groupingUsers = false; // flag if we're currently in a grouping users mode or not

			$scope.filters = {
				type: null,
				connection: null,
			};

			$scope.internetConnectivityType = DevicesService.getInternetConnectivityType();
			$scope.os = DevicesService.getOs();
			$scope.deviceCategory = DevicesService.getDeviceCategories();

			if (!$state.params.accountId) {
				showNotification('error', 'No Account Selected');
				$scope.loaded = false;
			}

			var account;

			$scope.rtChartData = {
				fulldata: [],
				olddata: [],
				showrates: 5000,
			};

			var emptyData = {
				name: '',
				size: 1,
			};

			window.stopUpdate = function () {
				$scope.loaded = false;
				console.log('stopping updates');
			};

			$scope.accountChartData = {
				fulldata: [],
				olddata: [],
				filtereddata: [],
				trafficcounter: { name: 'Usage',
					unit: 'Bytes',
					label: 'Bytes Transferred',
					labelFunc: function (value) {
						return $filter('bytes')(value, 0);
					} },
				from: 0,
				to: 0,
				appsdata: [emptyData],
				filteredappsdata: [],
			};

			$scope.hosts = [];
			$scope.link = null;
			$scope.links = {};
			$scope.expandedLinks = false;
			$scope.linkWidth = 0;
			$scope.openDropDowns = {
				sites: false,
				users: false,
				security: false,
			};

			$scope.hostsTableConfig = {
				titleSearch: 'Hosts',
				rt: true,
				dataURL: function () {
					if ($scope.currentObject.rootType !== 'site' || !$scope.currentObject.up) {
						return [];
					}

					return '/getHosts?accountId=' + $state.params.accountId + '&pid=' + $scope.currentObject.protoId +  '&siteId=' + $scope.currentObject.id + '&popId=' + $scope.currentObject.popId;
				},
				fields: [
					{ label: 'Name', path: 'name', template: '{{item.name}}' },
					{ label: 'Address', path: 'address', template: '{{item.address}}' },
					{ label: 'Type', path: 'type', template: '{{item.type}}' },
				],
				defer: true,
				fixedLayout: true,
				afterUpdate: function () {
					$scope.currentObject.fetchedHosts = true;
					$scope.$root.updateScroll('#inner-item');
				},
			};

			$scope.loginsTable = {
				titleSearch: 'VPN Users',
				dataURL: function() {
					return false;
				},
				parseData: function() {
					if (!$scope.currentObject || !$scope.currentObject.logins) {
						return [];
					}
					var items = [];
					for(var loginKey in $scope.currentObject.logins) {
						var item = $scope.currentObject.logins[loginKey];
                        item.name = item.login.name;
                        item.os = $scope.os[item.device.osType] + ' ' + item.device.osVersion;
                        item.clientVersionName = item.device.clientVersionName;
						items.push(item);
					}
					items = items.sort(function(v1, v2) {
						if (v1.name.toLowerCase() < v2.name.toLowerCase()) return -1;
						if (v1.name.toLowerCase() > v2.name.toLowerCase()) return 1;
						return 0;
					});

					this.pops = pops;
					this.searchVal = null;
					return items;
				},
				fields: [
					{ label: 'Name', noSort: true, path: 'name', template: '<div class="ellipsis"><span>{{item.name}}</span></div><div class="login-version-name ellipsis"><span>{{item.login.email}}</span></div>' },
					{ label: 'Client Details', noSort: true, path: 'os', template: '<div class="ellipsis"><span>OS: {{item.os}}</span></div><div class="login-version-name ellipsis"><span>Client: {{item.clientVersionName}}</span></div>'},
                    { label: 'PoP', noSort: true, path: 'pop', template: '<div class="ellipsis"><span>{{tableConfig.pops[item.popId].name}}</span></div>' }
				],
				defer: true,
				fixedLayout: true,
				pops: pops,
				clientSidePaging: true,
				clientSideSearch: true,
				clientSideSort: true,
				pageSize: 10,
				keepPageOnRefresh: true,
				useRegularUpdate: true,
			};


			$scope.currenthover = null;
			$scope.fetchhosts = new Date().getTime();
			$scope.currentObject = {
				// type: 'ACCOUNT'
			};

			$scope.topologyDetails = {
				sites: { online: [], pids: [] },
				users: { online: [], pids: [] },
			};

			var bladesCount = 5;
			$scope.accountDetails = {
				id: null,
				name: null,
				bladesNum: bladesCount,
				enabledBladesCount: 0,
				accessRulesEnabled: false,

				appRulesEnabled: false,
				urlFilteringEnabled: false,
				avConfigurationEnabled: false,
				ngAvConfigurationEnabled: false,
				ipsConfigurationEnabled: false,
			};

            SiteService.getConnectionTypes($state.params.accountId, function(data) {
                $scope.siteConnTypes = data.siteConnTypes;
            });

			$scope.siteTypes = [];

			EntityTypesService.getSiteTypes($state.params.accountId, function(siteTypes) {
				siteTypes.forEach(function(siteType) {
					$scope.siteTypes.push(siteType);
				});
			});

			$scope.$watch('searchSites', function (newVal, oldVal) {
				if (newVal !== oldVal) {
					$scope.$root.updateScroll('#sites-dropdown-menu .nano');
				}
			});

			$scope.$watch('searchUsers', function (newVal, oldVal) {
				if (newVal !== oldVal) {
					$scope.$root.updateScroll('#users-dropdown-menu .nano');
				}
			});

			/**
			 *  @desc checking if received parameter is a site in which the socket type is one who support multi tunnel
			 *  mode
			 *  @return bool - multiTunnelMode is enable for the given parameter
			 */
			$scope.isMultiTunnelMode = function (obj) {
				return (typeof obj !== 'undefined') && (obj.rootType == 'site' && (typeof obj.data.multiTunnelMode !== 'undefined') && obj.data.siteConnType.supportMultiTunnelMode);
			};


			$scope.getType = function (objType) {
				if (!objType) return;
				if (objType.indexOf('site') > -1) {
					return 'site';
				}
				return 'login';
			};

			$scope.isSite = function (objType) {
				if (!objType) return;
				return objType.indexOf('site') > -1;
			};

			$scope.isLogin = function (objType) {
				if (!objType) return;
				return objType.indexOf('login') > -1;
			};
			function allowNewSites() {
				store.fetch({
					path: '/allowNewSites?accountId=' + $state.params.accountId,
					success: function (data) {
						$scope.availableSiteLicenses = data;
					},
				});
			}
			allowNewSites();

			function allowNewUsers() {
				store.fetch({
					path: '/allowNewUsers?accountId=' + $state.params.accountId,
					success: function (data) {
						$scope.availableUserLicenses = data;
					},
				});
			}
			allowNewUsers();

            store.fetch({
                path: "/getAccountTimezone",
                queryParams: {
                    accountId: $state.params.accountId
                },
                success: function(data) {
                    $scope.accountTimezone = data;
                }
            });

            TimeZoneService.getTimeZones(function(timeZones) {
                $scope.timezones = timeZones;
            });

            store.fetch({
                path: '/countries',
                success: function (data) {
                    $scope.countries = data;
                }
            });

            $scope.isLocationSettingLoaded = function(){
                return ($scope.timezones != undefined && $scope.accountTimezone != undefined && $scope.countries != undefined);
            }

            // calculate timezone base on state
            $scope.calcTimezone = function(site){
                if (site.stateRaw != null && $scope.states[site.countryRaw] && $scope.states[site.countryRaw][site.stateRaw].timezone != null)
                    site.timezone = $scope.states[site.countryRaw][site.stateRaw].timezone;
            }

			$scope.addNew = function (type) {
				if ($scope.isSite(type)) {
					if ($scope.availableSiteLicenses.allowNew) {
						$scope.newSite = SiteService.getNewSite();
						$scope.newSite.siteConnType = _.findWhere($scope.siteConnTypes, {value: 'SOCKET_X1500'});
						$scope.updateNewSiteConnectivityType($scope.newSite);
                        $scope.newSite.timezone = $scope.accountTimezone;
						$scope.localIpInSiteCreation = false;
                        if (!$scope.loaded) {
                            return;
                        }
                        openAddSiteDlg();
					} else if($scope.availableSiteLicenses.isDisable){
                        $scope.$root.alert("Account license is Disable, please contact reseller for purchasing new license.");
                    } else{
					    $scope.$root.alert('There are no available licenses for new site, please contact reseller for purchasing new licenses.');
					}
				} else if ($scope.availableUserLicenses.allowNew) {
					$scope.newLogin = { id: GeneralUtilsService.getRandomId(), name: '', status: 'NEW' };
					$scope.$root.openPopup('addLoginDlg');
				} else if($scope.availableUserLicenses.isDisable){
                    $scope.$root.alert("Account license is Disable, please contact reseller for purchasing new license.");
                } else {
					$scope.$root.alert('There are no available licenses for new VPN users. Contact your reseller for purchasing new licenses.');
				}
			};

			$scope.add = function (type) {
				if (typeof $scope.availableSiteLicenses === 'undefined' || typeof $scope.availableUserLicenses === 'undefined' || typeof $scope.siteConnTypes === 'undefined') {
					$timeout(function () {
						$scope.add(type);
					}, 100, false);
				} else {
				    $scope.$root.clearErrors();
					$scope.addNew(type);
				}
			};


			$scope.addSite = function () {
				$scope.addItem('site');
			};

			$scope.validPasswordConfirm = false;

            $scope.updateNewSiteConnectivityType = function(site) {
                site.socketConnectionConfiguration = {};
                site.socketConnectionConfiguration.socketsSettings = {}; // need to prevent back-end from walking the socket migration path.
                SiteService.getCatoSocketsData($state.params.accountId, null, site.siteConnType, null, $scope.enableSecondaryWAN.value, site.socketConnectionConfiguration, function(data) {
                    SiteService.mergeNewSiteSocketConnection(site, data);
                });
				$scope.localIpInSiteCreation = (site.siteConnType?.value === "VSOCKET_VGX_AWS" || site.siteConnType?.value === "VSOCKET_VGX_AZURE");
			};

			$scope.addItem = function (type) {
				var modelType = (type === 'site' ? 'Site' : 'AccessLogin');
				var typeName = (type === 'site' ? 'Site' : 'User');
				var newItem;
				var prefix = (type === 'site' ? 'newSite' : 'newLogin');
				var dlg = (type === 'site' ? 'addSiteDlg' : 'addLoginDlg');
				var params = { accountId: $state.params.accountId, type: modelType, save: true };

				if (type === 'site') {
					if ($scope.newSite.siteConnType.socketModelTypeConfiguration) {

                        var defaultInterface = $scope.newSite.socketConnectionConfiguration.socketInterfaces.filter(function(inter) { return inter.role === 'wan_1'; })[0];

                        defaultInterface.downstreamBandwidth = $scope.newSite.wan1DownstreamBandwidth;
                        defaultInterface.upstreamBandwidth = $scope.newSite.wan1UpstreamBandwidth;

                        if ($scope.canUseSecondaryWan() && $scope.enableSecondaryWAN && $scope.enableSecondaryWAN.value == true){
                            var defaultInterface2 = $scope.newSite.socketConnectionConfiguration.socketInterfaces.filter(function(inter) { return inter.role === 'wan_2'; })[0];
                            defaultInterface2.downstreamBandwidth = $scope.newSite.wan2DownstreamBandwidth;
                            defaultInterface2.upstreamBandwidth = $scope.newSite.wan2UpstreamBandwidth;
                        }

                        $scope.newSite.socketConnectionConfiguration.preferHigherNaturalOrder = true;
                        $scope.newSite.socketConnectionConfiguration.fallbackPrecedenceDuration = {
                            length: 10,
                            unit: 'MINUTES'
                        };
                        $scope.newSite.socketConnectionConfiguration.acceptableNaturalOrder = 1;
                        $scope.newSite.socketConnectionConfiguration.fallbackPrecedenceDurationFactor = 2;
                    }

                    newItem = angular.copy($scope.newSite);
                    SiteService.fixSiteSocketData(newItem.socketConnectionConfiguration);

					$scope.loadingSaveNewSite = true;
				} else {
				    newItem = $scope.newLogin;
					$scope.loadingSaveNewLogin = true;
				}

				store.save({
					path: '/add',
					data: newItem,
					dataObj: 'json',
					queryParams: params,
					success: function (data) {
						if (modelType === 'Site') {
							$scope.loadingSaveNewSite = false;
						} else {
							$scope.loadingSaveNewLogin = false;
						}
						$scope.$root.handleServerResponse(data, prefix, typeName + ' added successfully');
						if (data.status !== 'ERROR') {
                            $scope.enableSecondaryWAN = {value :false};
							$scope.$root.closePopup(dlg);
							if (modelType === 'Site') {
								data.model.globalRange = [data.model.interfaces[0].globalRange.subnet];
								allowNewSites();
                                addNewNodes([{
                                    pid: data.model.protoId,
                                    site: data.model,
                                }]);
							} else {
								allowNewUsers();
								addNewNodes([{
                                    pid: data.model.protoId,
                                    login: data.model,
                                }]);
							}
                            refreshNodes(treeData);
						}
					},
				});
			};

			$scope.removeItem = function () {
				var type = ($scope.isSite($scope.currentObject.type) ? 'Site' : 'AccessLogin');
				var typeName = (type === 'Site' ? 'site' : 'user');
				var itemsToDelete = [$scope.currentObject.id];
				var item = $scope.currentObject;

				$scope.$root.confirm('Are you sure you want to remove the ' + typeName + ' ' + $scope.currentObject.name + '?', function () {
					store.remove({
						items: itemsToDelete,
						type: type,
						success: function (data) {
							$scope.$root.handleServerResponse(data, '', typeName + ' ' + $scope.currentObject.name + ' removed successfully');
							if (data.status !== 'ERROR') {
								if (type === 'Site') {
									var dbItem = item.pid;
									removeNode(dbItem);
									$scope.topologyDetails.sites.pids.splice($scope.topologyDetails.sites.pids.indexOf(dbItem), 1);
									delete updateData.dbData[dbItem];
									refreshNodes(treeData);
								}
							}
						},
					});
				});
			};

			$scope.getStatesAndLicense = function (country) {
				if (country.filename) {
					store.fetch({
						path: '/states?country=' + country.filename,
						success: function (data) {
							$scope.states[country.code] = data;
						},
					});
				} else {
					$scope.states[country.code] = [];
					if (country.timezone != null){
                        $scope.newSite.timezone = country.timezone[0];
                    }
				}
				$scope.sitesUsage = [];
				store.fetch({
					path: '/planAvailableSiteUsage?accountId=' + $scope.accountDetails.id + '&zone=' + country.zone,
					success: function (data) {
						$scope.sitesUsage.newSite = data.items;
					},
				});
			};

			$scope.config = function (configObject) {
				if ($scope.isSite(configObject.type) || configObject.type === 'SITE') {
					$state.go('app.sites', {
						id: configObject.id,
					});
				} else {
					$state.go('app.logins', {
						id: configObject.id,
					});
				}
			};

			$scope.monitor = function (action, entity) {
				entity = entity || $scope.currentObject;

				var type = (($scope.isSite(entity.type) || entity.type === 'SITE') ? 'Site' : 'Login');

				var monitoringFilter = {
					pid: entity.protoId || entity.pid,
					name: entity.name,
					type: (type === 'Site' ? 'site' : 'login'),
				};

				var state;
				if (action == 'monitor') {
					if (entity.logins) {
						// logins group, go to logins analytics page
						$state.go('app.monitorLogins');
						return;
					} else {
						if (type === 'Site') {
							state = 'app.monitor';
						} else {
							state = 'app.monitor' + $filter('capitalize')(monitoringFilter.type);
						}
					}

				} else if (action == 'events') {
					state = 'app.eventsDiscovery';
				}

				$state.go(state, {
					filter: angular.toJson(monitoringFilter),
				});
			};


			$scope.resetPassword = function () {
				var items = [$scope.currentObject.id];
				var data = { items: items, type: 'ACCESSLOGIN' };
				var len = items.length;
				if (len === 0) {
					$scope.$root.alert('Please select users');
					return;
				}
				$scope.$root.confirm('Are you sure you want to reset password to the user ' + $scope.currentObject.name + '?', function () {
					store.action({
						path: 'resetPasswords',
						data: data,
						dataObj: 'json',
						success: function (data) {
							$scope.$root.handleServerResponse(data, '', 'Passwords were reset and invitations were send to the user ' + $scope.currentObject.name, null, true);
						},
					});
				});
			};

			$scope.openPWDlg = function () {
				$scope.$root.openPopup('changePW');
			};


			$scope.changePassword = function () {
				var type = $scope.currentObject.type.toLowerCase();
				if (!$scope.isSite(type)) {
					$scope.$root.confirm('Are you sure you want to reset password to the user ' + $scope.currentObject + '?', function () {
						$scope.currentObject.pw = 'RESET_PW';
						changePassWord('accessLogin');
					});
					return;
				}

				changePassWord('site');
			};

			function changePassWord(type) {
				var queryParams = { save: true,fields: "['pw']",accountId: $state.params.accountId };
				queryParams[type + 'Id'] = $scope.currentObject.id;
				$scope.currentObject.newSaveMethod = true;

				store.save({
					path: '/edit',
					data: $scope.currentObject,
					dataObj: 'json',
					queryParams: queryParams,
					success: function (data) {
						$scope.$root.handleServerResponse(data, type, 'Password changed successfully');
						$scope.$root.closePopup('changePW');
					},
				});
			}

			$scope.modifyBlades = function () {
				bladesConfirmOpen = false;
				var queryParams = { save: true, accountId: $scope.accountDetails.id };
				store.save({
					path: '/modifyBlades',
					data: { accessRules: $scope.accountDetails.accessRulesEnabled, appRules: $scope.accountDetails.appRulesEnabled, urlFiltering: $scope.accountDetails.urlFilteringEnabled, avConfiguration: $scope.accountDetails.avConfigurationEnabled, ipsConfiguration: $scope.accountDetails.ipsConfigurationEnabled, ngAvConfiguration: $scope.accountDetails.ngAvConfigurationEnabled },
					dataObj: 'json',
					queryParams: queryParams,
					success: function (data) {
						$scope.$root.handleServerResponse(data, $scope.entityType, 'Service modules modified successfully');
						$scope.$root.closePopup('bladedModifedDlg');
						$scope.orig = angular.copy($scope.accountDetails);
						$scope.accountDetails.enabledBladesCount = getEnabledBladesCount();
					},
				});
			};

			$scope.cancelBlades = function () {
				bladesConfirmOpen = false;
				$('input#accessRulesEnabledCheckbox').prop('checked', $scope.orig.accessRulesEnabled);
				$('input#appRulesEnabledCheckbox').prop('checked', $scope.orig.appRulesEnabled);
				$('input#urlFilteringEnabledCheckbox').prop('checked', $scope.orig.urlFilteringEnabled);
				$('input#avConfigurationEnabledCheckbox').prop('checked', $scope.orig.avConfigurationEnabled);
				$('input#ngAvConfigurationEnabledCheckbox').prop('checked', $scope.orig.ngAvConfigurationEnabled);
				$('input#ipsConfigurationEnabledCheckbox').prop('checked', $scope.orig.ipsConfigurationEnabled);
				$scope.accountDetails.accessRulesEnabled = $scope.orig.accessRulesEnabled;
				$scope.accountDetails.appRulesEnabled = $scope.orig.appRulesEnabled;
				$scope.accountDetails.urlFilteringEnabled = $scope.orig.urlFilteringEnabled;
				$scope.accountDetails.avConfigurationEnabled = $scope.orig.avConfigurationEnabled;
				$scope.accountDetails.ngAvConfigurationEnabled = $scope.orig.ngAvConfigurationEnabled;
				$scope.accountDetails.ipsConfigurationEnabled = $scope.orig.ipsConfigurationEnabled;
				$scope.$root.closePopup('bladedModifedDlg');
			};

			$('#bladedModifedDlg').on('hidden.bs.modal', function (e) {
				//console.log('hiding blades modified dlg');
				if (bladesConfirmOpen) {
					$scope.cancelBlades();
				}
			});

			$scope.$on('$toggleClicked', function (event, id, checked) {
				bladesConfirmOpen = true;

				var action = checked ? 'disable' : 'enable';
				var message, moduleText;

				switch (id) {
					case 'accessRulesEnabledCheckbox':
						moduleText = 'WAN Firewall';
						break;
					case 'appRulesEnabledCheckbox':
						moduleText = 'Internet Firewall';
						break;
					case 'urlFilteringEnabledCheckbox':
						moduleText = 'URL Filtering';
						break;
					case 'avConfigurationEnabledCheckbox':
						moduleText = 'Malware Protection';
						if (action === 'disable' && $scope.accountDetails.ngAvConfigurationEnabled) {
                        	moduleText += ' And NG Malware Protection';
                        	$scope.accountDetails.ngAvConfigurationEnabled = false;
                        }
						break;
					case 'ngAvConfigurationEnabledCheckbox':
                    	moduleText = 'NG Malware Protection';
                    	break;
					case 'ipsConfigurationEnabledCheckbox':
						moduleText = 'IPS';
						break;
				}

				if (action === 'disable') {
					message = 'Are you sure you want to disable ' + moduleText + '?';
				} else {
					message = 'Clicking OK will enable ' + moduleText;
				}

				$scope.bladedModifedDlgMessage = message;
				$scope.$root.openPopup('bladedModifedDlg');
			});

			$scope.toggleEdit = function () {
				$scope.currentObject.editMode = !$scope.currentObject.editMode;
			};

			$scope.expandLinks = function () {
				$scope.expandedLinks = !$scope.expandedLinks;
			};

			$('body').click(checkDropdowns);

			function checkDropdowns(evt) {
				if ($scope.openedDropdown && $(evt.target).parents('.drop-down').length == 0) {
					$scope.openDropDowns[$scope.openedDropdown] = false;
					$scope.openedDropdown = null;
				}
			}

			$scope.openDropDown = function ($event, dropdown) {
				$event.stopPropagation();
				if ($scope.openedDropdown) {
					$scope.openDropDowns[$scope.openedDropdown] = false;
				}

				if ($scope.openedDropdown != dropdown) {
					$scope.openDropDowns[dropdown] = !$scope.openDropDowns[dropdown];
				}

				$scope.openedDropdown = $scope.openDropDowns[dropdown] ? dropdown : null;

				$scope.$root.updateScroll('#' + dropdown + '-dropdown-menu .nano');

				$timeout(()=> {
					$('.' + dropdown + '-drop-down .search').focus();
				},0,false);
			};

			$scope.select = function (entity) {
				const node = _.findWhere(treeData, { id: entity.pid });
				if (node) {
					nodeClick(node);
				}
			}

			function openSearchSites(event) {
				if((event.ctrlKey || event.metaKey) && event.which === 70) {
					event.preventDefault();
					$scope.openDropDown(event, "sites");
					$scope.$digest();
					return false;
				}
			}
			$(document).keydown(openSearchSites);

			$scope.setFilter = function (filter) {
				$scope.filters.connection = filter;
				refreshNodes(treeData, foundAccount);
			};

			var labelType,
				nativeTextSupport,
				useGradients,
				animate,
				iphone;
			(function () {
				var ua = navigator.userAgent,
					iStuff = ua.match(/iPhone/i) || ua.match(/iPad/i),
					typeOfCanvas = typeof HTMLCanvasElement,
					nativeCanvasSupport = (typeOfCanvas === 'object' || typeOfCanvas === 'function'),
					textSupport = nativeCanvasSupport && (typeof document.createElement('canvas').getContext('2d').fillText === 'function');
				// I'm setting this based on the fact that ExCanvas provides text support for IE
				// and that as of today iPhone/iPad current text support is bad
				labelType = (!nativeCanvasSupport || (textSupport && !iStuff)) ? 'Native' : 'HTML';
				nativeTextSupport = labelType === 'Native';
				useGradients = nativeCanvasSupport;
				animate = !(iStuff || !nativeCanvasSupport);
				iphone = iStuff;
			}());

			var icons = {};
			setIcons();

			function openAddSiteDlg() {
			    $scope.$broadcast('confirmpw-clearPw');
                $scope.$root.openPopup('addSiteDlg');
			}

			function addIcon(name, src) {
				icons[name] = {
					img: new Image(),
				};
				icons[name].img.onload = function () {
					icons[name].loaded = true;
				};
				icons[name].img.src = src;
			}

			function setIcons() {
				var icons = DevicesService.getDevicesIcons();
				for (var iconKey in icons) {
					addIcon(iconKey, icons[iconKey]);
				}
				addIcon('cloud', '/public/images/ring.png');
				addIcon('down', '/public/images/X.png');
				addIcon('alternativeWanCircle', '/public/images/alternativeWanCircle.png');
				addIcon('alternativeWan', '/public/images/alternativeWan.png');
				addIcon('alternativeWanConnected', '/public/images/alternativeWanConnected.png');
				addIcon('alternativeWanConnectedButCatoDisconnected', '/public/images/alternativeWanGrey.png');
				addIcon('s2sCircle', '/public/images/s2sCircle.png');
				addIcon('s2s', '/public/images/s2s.png');
				addIcon('s2sConnected', '/public/images/s2sConnected.png');
			}

			var force = 1;

			function implementRG() {
				var icon;

				if (!$scope.loaded) {
					return;
				}

				if (force < 100) {
					for (icon in icons) {
						if (!icons[icon].loaded) {
							timeouts.implementTimeout = $timeout(implementRG, 50, false);
							force++;
							return;
						}
					}
				}


				function renderIcon(node, c, icon) {
					var pos = node.pos.getc(true);
					var ctx = c.getCtx(),
						dim = node.getData('dim');
					ctx.save();
					ctx.translate(pos.x, pos.y);

					dim *= 0.5;

					ctx.drawImage(icon, -2.5 * dim, -2.5 * dim, 5 * dim, 5 * dim);
					ctx.restore();
				}

				for (icon in icons) {
					(function (thisIcon) {
						var newNodeType = {};
						newNodeType[thisIcon] = {
							render: function (node, c) {
								renderIcon(node, c, icons[thisIcon].img);
							},
							contains: function (node, pos) {
								return $jit.Graph.Plot.nodeHelper.square.contains(node.pos.getc(), pos, node.getData('dim'));
							},
						};

						$jit.RGraph.Plot.NodeTypes.implement(newNodeType);
					}(icon));
				}


				$jit.RGraph.Plot.NodeTypes.implement({
					transparent: {
						render: function (node, c) {
						},
						contains: function (node, pos) {
						},
					},
					pop: {
						render: function (node, c) {
						},
						contains: function (node, pos) {
						},
					},
				});

				implemented = true;
			}

			/*
			 init tree
			 redraw - force a redraw of the rgraph after the next fetch of data
			 */
			function init(redraw) {
				if (!treeData || treeData.length === 0) {
					getTree();
				}

				for (var i = 1; i < MIN_NODES; i++) {
					addPop(i);
				}

				getNewData(false, redraw);
				IntervalService.dynamicInterval(getNewData, $scope.$id, 'networkTopoGetTopo', false);

				updateLastUpdate();

				return true;
			}


			implementRG();

			function refreshWindowSize() {
				var $content = $('#topology-wrapper');
				if ($content.length === 0) {
					return false;
				}

				var targetTop = $(window).height() - $('#navbar-top').height() - 40;
				var targetRight = $('topology-left').width();

				containerEl.innerHTML = '';
				var targetHeight = (targetTop - $('#topology-headers').height() - 5);
				containerEl.style.height = targetHeight + 'px';
				containerEl.style.width = targetRight + 'px';

				var $itemInfo = $('#topology-right');
				var $itemInner = $('#inner-item');
				$itemInfo.css({
					maxHeight: (targetTop + 10) + 'px',
				});
				$itemInner.css('height', (targetTop - 60) + 'px');
				// $itemInner.children().css('height', (targetTop - 66 ) + 'px');
				return targetHeight;
			}

			function drawRgraph(nodes, redraw) {
				var nodesCount = 0;
				var hasLogins = false;

				if (nodes) {
					let country = null;
					var siteIds = [];
					nodes.forEach(function (item) {
						if (item.pid>=1000000000) { //if site
							if (siteIds.indexOf(item.pid) < 0) {
								nodesCount++;
								siteIds.push(item.pid);
							}
							if (item.site?.country) {
								if (country === null) {
									country = item.site.country;
								} else {
									if (country !== item.site.country) {
										showFlags = true; // we hide flags only if all sites are in the same country
									}
								}
							}
						} else if (item.status === 'up' && !groupingUsers) { // only increase number of nodes if we're not in groupingUsers mode
							nodesCount++;
							hasLogins = true;
						}
					});
					if (groupingUsers) {
						nodesCount++;
					}
				} else {
					nodesCount = $scope.topologyDetails.sites.pids.length + ($scope.topologyDetails.users.online.length || 0);
					hasLogins = !!$scope.topologyDetails.users.online.length;
				}

				wheelMode = nodesCount > MIN_NODES_COUNT_FOR_DISTANCEMODE;
				const targetHeight = refreshWindowSize();


				let levelDistance;

				if (wheelMode) {
					const R = Math.max(nodesCount * (SITE_SIZE / 5), 200);
					const graphSize = 5 * R + 100;
					scale = targetHeight / graphSize;
					levelDistance = R

					$(containerEl).addClass('manyNodes');

					var minScale = 0.2;
					if (nodesCount > 100) {
						if (targetHeight < 700) {
							minScale = 0.07;
						} else {
							minScale = 0.09;
						}
					} else if (targetHeight > 700) {
						minScale = 0.1;
					}
					scale = Math.max(scale, minScale);
				} else {
					levelDistance = 130;
					$(containerEl).removeClass('manyNodes');
					if (targetHeight < 600) {
						scale = 0.8;
					} else {
						scale = 0.95;
					}
				}

				if (redraw) { // don't rescale if this is a redraw
					scale = rgraph.canvas.scaleOffsetX; // scaleX and scaleY are synced
				}

				rgraph = new $jit.RGraph({
					injectInto: 'infovis',
					levelDistance: levelDistance,
					closerInner: true,
					Navigation: {
						enable: true,
						panning: 'avoid nodes',
						zooming: 20,
					},
					Node: {
						overridable: true,
						color: '#ccddee',
						dim: 12,
					},
					Edge: {
						overridable: true,
						color: '#C17878',
					},
					Label: {
						overridable: true,
						type: 'HTML',
						size: 11,
						family: 'Verdana',
						color: '#000000',
					},
					Events: {
						enableForEdges: true,
						enable: true,
						type: 'Native',
						onMouseEnter: function (node, eventInfo, event) {
							if (eventInfo && eventInfo.edge && eventInfo.edge.point) {
								var mod = 10;
								if ((eventInfo.edge.point.left - mod < eventInfo.pos.x && eventInfo.edge.point.right + mod > eventInfo.pos.x ||
									eventInfo.edge.point.left + mod > eventInfo.pos.x && eventInfo.edge.point.right - mod < eventInfo.pos.x) &&
									(eventInfo.edge.point.top - mod < eventInfo.pos.y && eventInfo.edge.point.bottom + mod > eventInfo.pos.y ||
									eventInfo.edge.point.top + mod > eventInfo.pos.y && eventInfo.edge.point.bottom - mod < eventInfo.pos.y)) {
									var throughput = 0,
										popId;
									if ($scope.isSite(eventInfo.edge.nodeFrom.data.type) ||
										$scope.isLogin(eventInfo.edge.nodeFrom.data.type)) {
										throughput = eventInfo.edge.nodeFrom.data.throughput;
										popId = eventInfo.edge.nodeFrom.data.popId;
									} else if ($scope.isSite(eventInfo.edge.nodeTo.data.type) ||
										$scope.isLogin(eventInfo.edge.nodeTo.data.type)) {
										throughput = eventInfo.edge.nodeTo.data.throughput;
										popId = eventInfo.edge.nodeTo.data.popId;
									}

									if (popId || popId == 0) {
										var $infolabel = $('#infolabel');

										rgraph.canvas.getElement().style.cursor = 'default';
										var currentPopNode = _.findWhere(treeData, { id: 'pop' + popId });
										if (currentPopNode.name === DEFAULT_POP_NAME && pops[popId] && pops[popId].name) {
											currentPopNode.name = pops[popId].name;
										}

										$infolabel.css('visibility', 'hidden');

										$scope.$apply(function () {
											$scope.currenthover = {
												throughput: throughput,
												pop: currentPopNode.name,
											};
										});

										$timeout(function () {
											$infolabel.data('edgeindex', eventInfo.edge.data.index);
											$infolabel.css({
												left: event.clientX - ($infolabel.outerWidth() / 2) - ($('body').hasClass('miniMenu') ? 80 : 245),
												top: event.clientY - 90 - $infolabel.outerHeight() - (eventInfo.pos.y - eventInfo.edge.point.top),
												visibility: 'visible',
											});
										}, 1, false);
									}
								}
							}
							if (node && node.id && (node.data.rootType === 'site' || $scope.isLogin(node.data.type))) {
								if (node._depth <= 1) {
									document.getElementById(node.id).style.display = 'block';
									return;
								}
								rgraph.canvas.getElement().style.cursor = 'pointer';
							}
						},
						onMouseLeave: function (node) {
							if ($scope.currenthover) {
								$scope.currenthover = null;
							}

							if (node._depth <= 1) {
								document.getElementById(node.id).style.display = 'none';
							}
							rgraph.canvas.getElement().style.cursor = 'move';
						},
						onClick: function (node) {
							nodeClick(node);
						},
						onDragMove: function (node, eventInfo, e) {
							$jit.util.event.stop(e);
							nodeClick(node);
						},
					},
					onBeforePlotNode: function (node) {
						if ($scope.filters.connection === 'Alternative WAN') {
							if (node.data.rootType !== 'site' || !node.data.alternativeWAN) {
								node.data.$type = 'transparent';
							}
						} else if ($scope.filters.connection === 'S2S') {
							if (node.data.rootType !== 'site' || !node.data.S2S) {
								node.data.$type = 'transparent';
							}
						}
					},
					onAfterPlotNode: function (node) {
						if ($scope.accountDetails) {
							if ($scope.accountDetails.hasSDWAN) {
								if (!$scope.filters.connection || $scope.filters.connection === 'Alternative WAN') {
									if (node.data.rootType === 'site' && node.data.alternativeWAN) {
										drawAlternativeWan(node, node.data.alternativeWAN.online);
									}
								}
							}
							if ($scope.accountDetails.hasS2S) {
								if (!$scope.filters.connection || $scope.filters.connection === 'S2S') {
									if (node.data.rootType === 'site' && node.data.S2S) {
										drawS2S(node, node.data.S2S.online);
									}
								}
							}
						}
					},
					onAfterPlotLine: function (adj) {
						var currentNode = adj.nodeTo.data.rootType === 'site' ? adj.nodeTo : (adj.nodeFrom.data.rootType === 'site' ? adj.nodeFrom : null);

						if (currentNode) {
							if ($scope.filters.connection === 'Alternative WAN') {
								if (currentNode.data.alternativeWAN && !currentNode.data.alternativeWAN.online) {
									drawX(adj);
								}
							} else if ($scope.filters.connection === 'S2S') {
								if (currentNode.data.S2S && !currentNode.data.S2S.online) {
									drawX(adj);
								}
							} else if (!currentNode.data.up) {
								drawX(adj);
							}
						}
					},
					onBeforePlotLine: function (adj) {
						if ($scope.filters.connection === 'Alternative WAN') {
							if ((adj.nodeFrom.data.rootType !== 'site' || !adj.nodeFrom.data.alternativeWAN) &&
								(adj.nodeTo.data.rootType !== 'site' || !adj.nodeTo.data.alternativeWAN)) {
								adj.data.$color = 'white';
								adj.data.$lineWidth = 0.001;
							} else {
								adj.data.$lineWidth = 0;
								adj.data.$color = 'gray';
							}
						} else if ($scope.filters.connection === 'S2S') {
							if ((adj.nodeFrom.data.rootType !== 'site' || !adj.nodeFrom.data.S2S) &&
								(adj.nodeTo.data.rootType !== 'site' || !adj.nodeTo.data.S2S)) {
								adj.data.$color = 'white';
								adj.data.$lineWidth = 0.001;
							} else {
								adj.data.$lineWidth = 0;
								adj.data.$color = 'gray';
							}
						} else if (((adj.nodeTo.data.type === 'pop' && !adj.nodeTo.data.up) ||
							(adj.nodeFrom.data.type === 'pop' && !adj.nodeFrom.data.up) ||
							adj.nodeFrom.data.$type === 'transparent' || adj.nodeTo.data.$type === 'transparent')) {
							adj.data.$color = 'white';
							adj.data.$lineWidth = 0.001;
						} else if (adj.nodeFrom.data.type === 'pop' && adj.nodeTo.data.type === 'pop') {
							adj.data.$lineWidth = 0.001;
						} else {
							var up = adj.nodeFrom.data.up && adj.nodeTo.data.up;
							var throughput;
							if (adj.nodeFrom.data.type === 'groupnode') {
								if (adj.nodeTo.data.type === 'pop') {
									throughput = adj.nodeFrom.data.throughput;
								} else {
									throughput = adj.nodeTo.data.throughput;
								}
							} else if (adj.nodeTo.data.type === 'groupnode') {
								if (adj.nodeFrom.data.type === 'pop') {
									throughput = adj.nodeTo.data.throughput;
								} else {
									throughput = adj.nodeFrom.data.throughput;
								}
							} else {
								throughput = adj.nodeFrom.data.throughput || adj.nodeTo.data.throughput;
							}

							throughput = throughput || 0;

							if (up) {
								adj.data.$color = $jit.util.shadeBlend(throughput / treeData[0].data.throughput, MIN_TRAFFIC_COLOR, '#000');
								if (adj.nodeFrom.data.type !== 'pop' && !adj.nodeFrom.data.logins) {
									drawDataPoint(adj);
								}
							} else {
								adj.data.$lineWidth = 0;
								adj.data.$color = 'gray';
							}
						}
					},
					onCreateLabel: function (domElement, node) {
						var targetHTML = domElement.innerHTML;
						targetHTML += "<div class='node-wrapper'>";
						if (showFlags && node.data.data && node.data.data.country) {
							targetHTML += '<span class="flag-wrapper"><span  class="flag-icon flag-icon-' + node.data.data.country.toLowerCase() + '"></span></span>';
						}
						var nameSpan = document.createElement('span');
						if (node.id === loginsGroupId && node.data.logins) {
							nameSpan.innerText = Object.keys(node.data.logins).length + ' ' + node.name;
						} else {
							nameSpan.innerText = node.name;
						}

						var nameHTML = '<div class="name">' + nameSpan.innerHTML;

						targetHTML += nameHTML + '</div></div>';

						domElement.innerHTML = targetHTML;

						domElement.onclick = function () {
							nodeClick(node);
						};
					},
					onCompletePlot: function () {
						var circleImage, alternative;
						switch ($scope.filters.connection) {
							case 'Alternative WAN':
								circleImage = icons.alternativeWanCircle.img;
								alternative = true;
								break;
							case 'S2S':
								circleImage = icons.s2sCircle.img;
								alternative = true;
								break;
							default:
								circleImage = icons.cloud.img;
								break;
						}

						drawCircle(alternative, circleImage);
					},
					onBeforeCompute: function () {

					},
					onPlaceLabel: function (domElement, node) {
						placeNode(domElement, node);
					},
				});

				rgraph.canvas.scale(scale, scale);
			}

			function placeNode(domElement, node) {
				var style = domElement.style;
				var left = parseInt(style.left);
				var top = parseInt(style.top);

				if (node.name === '' || (node.data.$type === 'circle' && !node.data.up) || node.data.$type === 'transparent' || node._depth <= 1) {
					style.display = 'none';
					return;
				}

				var $labelEl = $(domElement);

				$labelEl.addClass('depth-' + node._depth);

				if (node.data.color) {
					$labelEl.addClass('selected');
				} else {
					$labelEl.removeClass('selected');
				}

				style.color = node.data.color;
				$labelEl.removeClass('rotate');

				left -= domElement.offsetWidth / 2;

				var factor = 70;

				if (node.pos.theta > LABELS_LIMITS.rightTop && node.pos.theta < LABELS_LIMITS.rightBottom) {
					if (node.data.rootType === 'site') {
						factor -= 35;
					} else {
						factor -= 35;
					}

					if (node.data.color) {
						factor += 5;
					}
				} else if (node.pos.theta < LABELS_LIMITS.bottom) {
					if (node.data.rootType === 'site') {
						factor -= 10;
					} else {
						factor -= 20;
					}

					if (node.data.color) {
						factor += 5;
					}
				} else if (node.pos.theta < LABELS_LIMITS.left) {
					if (node.data.rootType === 'site') {
						factor += 5;
					} else {
						factor += 0;
					}

					if (node.data.color) {
						factor += 15;
					}
				} else if (node.pos.theta < LABELS_LIMITS.leftTop) {
					if (node.data.rootType === 'site') {
						factor += 10;
					} else {
						factor -= 10;
					}

					if (node.data.color) {
						factor += 15;
					}
				}

				var i, k;
				if (wheelMode) {
					var targetDeg = node.pos.theta * (LABELS_LIMITS.middle);
					var margin = -5;
					var marginSide = 'marginLeft';

					factor = 100;

					if (targetDeg > 60 && targetDeg < 120) {
						factor -= 20;
						margin = 13;
					}

					if (targetDeg > 180 && targetDeg < 270) {
						factor += 10;
						margin = -15;
					}

					if (targetDeg > 270) {
						factor += 5;
						margin = -10;
					}

					if (targetDeg > 90 && targetDeg < 270) {
						targetDeg = 270 + (targetDeg - 90);
						$labelEl.addClass('rotate');
						marginSide = 'marginRight';
					}

					for (i = 0; domElement.children[i]; i++) {
						domElement.children[i].style.transform = 'rotate(' + (targetDeg) + 'deg)';
						margin = margin * (1-scale);
						domElement.children[i].children[0].style[marginSide] = margin + 'px';
					}
				} else {
					for (i = 0; domElement.children[i]; i++) {
						domElement.children[i].style.transform = null;
					}
				}

				var labelPolarPos = new $jit.Polar(node.pos.theta, node.pos.rho + factor);
				var labelComplexPos = labelPolarPos.toComplex();
				var nodeComplexPos = node.pos.getc();

				top += (labelComplexPos.y - nodeComplexPos.y);
				left += (labelComplexPos.x - nodeComplexPos.x);

				style.left = left + 'px';
				style.top = top + 'px';
			}

			function nodeClick(node) {
				if (!node || node._depth <= 1) {
					return;
				}

				if (lockNode && node.id === lockNode) {
					return;
				}

				lockNode = node.id;
				timeouts.preventNodeDblClick = $timeout(function () {
					lockNode = null;
				}, 50, false);

				var currentNode = _.findWhere(treeData, { id: node.id });

				if (!currentNode) {
					return;
				}

				$('#infovis-label').find('.node').removeClass('selected');

				treeData.forEach(function (item) { item.data.color = ''; });

				if (node.data.color !== ONLINE_COLOR) {
					selectNode(node.data);
					currentNode.data.color = ONLINE_COLOR;
				} else {
					unSelectNode(node.data);
					currentNode.data.color = '';
				}

				refreshNodes(treeData, foundAccount);
			}

			angular.element(document).ready(function () {
				if (!$scope.loaded) {
					return;
				}

				if (init()) {
					getAccountStats()
					IntervalService.dynamicInterval(getAccountStats, $scope.$id, 'networkTopoGetAccountStats', true);

					windowResize = function () {
						if (rgraph) {
							init(true);
						}

						$timeout(function () {
							$scope.linkWidth = $('#inner-iteminfo').width() - 30;
						}, 1, false);

						setPieChartSize(appsPieChart, $(window).width());
					};

					$(window).resize(windowResize);
					handleVisibilityChange = function() {
						if (!$scope.loaded) {
							return;
						}
						if (!document.hidden) {
							windowResize();
						}
					};

					document.addEventListener("visibilitychange", handleVisibilityChange, false);
				}
			});

			function setPieChartSize(pieChart, windowWidth) {
				if (!pieChart){
					return;
				}

				var largeVersion = windowWidth > 1599;

				pieChart.maxLabelWidth = largeVersion ? 100 : 50;
				pieChart.marginTop = largeVersion ? 20 : 10;
				pieChart.marginBottom = largeVersion ? 20 : 10;
			}

			function getAppsData(pid, from, to, type) {
				var windowWidth = $(window).width();
				var resultsNum = windowWidth > 1700 ? 8 : 5;

				if (pid) {
					if (!$scope.accountChartData.appsdata) {
						timeouts.getAppsTimeout = $timeout(function () {
							getAppsData(pid, from, to);
						}, 100, false);
						return;
					}
				}

				store.fetch({
					path: '/getTrafficDataUpdate',
					method: 'POST',
					rt: true,
					queryParams: {
						accountId: $state.params.accountId,
						type: 'main',
						fromDate: from,
						toDate: to,
						interval: 60 * 60 * 1000,
						pid: pid || null,
					},
					dataObj: 'dataConfig',
					data: { dateField: '', fromDate: 0, toDate: 0, from: 0, limit: resultsNum, searchField: 'name', orders: [{ path: 'size', dir: 'DESC' }], type: 'app' },
					success: function (data) {
						if (!$scope.loaded) {
							return;
						}

						if (!appsPieChart) {
							appsPieChart = AmCharts.makeChart('apps-mini-pie', {
								type: 'pie',
								addClassNames: true,
								theme: 'new',
								fontFamily: 'Roboto',
								creditsPosition: 'bottom-right',
								dataProvider: [],
								valueField: 'size',
								titleField: 'name',
								fontSize: 8,
								innerRadius: '45%',
								labelRadius: 2,
								maxLabelWidth: windowWidth > 1700 ? 100 : 50,
								labelsEnabled: true,
								adjustPrecision: true,
								autoMargins: false,
								marginTop: windowWidth > 1700 ? 15 : 5,
								marginBottom: windowWidth > 1700 ? 10 : 5,
								percentPrecision: 1,
								precision: 1,
								pullOutRadius: 0,
								startAngle: 45,
								hideLabelsPercent: 1,
								balloon: {
									fixedPosition: true,
									maxWidth: '80',
								},
							});

							setPieChartSize(appsPieChart, windowWidth);
						}


						if ((pid && pid !== $scope.currentObject.protoId) || !data) {
							return;
						}
						var appsData = [];
						if (data.items && data.items.length > 0) {
							data.items.forEach(function (dataItem) {
								var tData = {};
								tData.name = dataItem.application.display_name || 'Unknown';
								tData.class = dataItem.application.category || 'Unknown';
								tData.size = dataItem.counters.BytesReceived + dataItem.counters.BytesSent;
								appsData.push(tData);
							});
							$('#apps-mini-pie').css('opacity', 1);
						} else {
							appsData = [emptyData];
							$('#apps-mini-pie').css('opacity', 0.3);
						}

						appsPieChart.dataProvider = appsData;
						appsPieChart.validateData();

						if (!pid) {
							$scope.accountChartData.appsdata = appsData;
						}

						$scope.loaders.apps = false;
						$scope.$digest();
					},
				});
			}

			$scope.chartsSettings = {
				type: 'serial',
				fontFamily: 'Roboto',
				addClassNames: true,
				path: '/public/javascripts/external/amcharts/',
				pathToImages: '/public/javascripts/external/amcharts/images/',
				categoryField: 'sampleTime',
				theme: 'new',
				autoMarginOffset: 10,
				categoryAxis: {
					gridAlpha: 0.15,
					minPeriod: '2500fff',
					markPeriodChange: true,
					parseDates: true,
					dateFormats: [{ period: 'fff', format: 'JJ:NN:SS' }, { period: 'ss', format: 'JJ:NN:SS' }, { period: 'mm', format: 'JJ:NN' }, { period: 'hh', format: 'JJ:NN' }, { period: 'DD', format: 'MMM DD' }, { period: 'WW', format: 'MMM DD' }, { period: 'MM', format: 'MMM' }, { period: 'YYYY', format: 'YYYY' }],

				},
				chartCursor: {
					cursorPosition: 'mouse',
					selectWithoutZooming: true,
					categoryBalloonDateFormat: 'JJ:NN:SS, MMM DD, YYYY',
				},
				trendLines: [],
				legend: {
					position: 'bottom',
					markerBorderThickness: 2,
					markerType: 'line',
					fontSize: 10,
					enabled: true,
					align: 'center',
					valueText: '',
					autoMargins: false,

				},
				graphs: [
					{
						lineThickness: 2,
						dateFormat: 'JJ:NN:SS DD, YYYY',
						fillAlphas: 0.33,
						fontSize: 4,
						id: 'AmGraph-1',
						title: 'Account',
						valueField: 'throughputTotal',
						valueAxis: 'ValueAxis-1',
						balloonFunction: function (graphDataItem) {
							return $filter('bits')(graphDataItem.values.value, 1) + 'ps';
						},
					},
				],
				guides: [],
				valueAxes: [
					{
						id: 'ValueAxis-1',
						title: 'Throughput',
						labelsEnabled: true,
						titleFontSize: 10,
						gridAlpha: 0,
						axisAlpha: 1,
						includeHidden: true,
						axisThickness: 2,
						labelFunction: function (value) {
							return $filter('bits')(value, 1) + 'ps';
						},
					},
				],
				allLabels: [],
				export: {
					enabled: true,
				},
			};

			function getAccountTrafficData() {
				store.fetch({
					rt: true,
					path: '/getTopologyRealTimeStats',
					method: 'POST',
					skipParsePostData: true,
					queryParams: {
						accountId: $state.params.accountId,
						interval: $scope.accountChartData.intervals,
						fromDate: $scope.accountChartData.from,
						toDate: $scope.accountChartData.to,
						mock: false,
						rtStats: true,
						type: 'account',
						numberOfSegments: NUMBER_OF_SEGMENTS,
						deviceAggregationType: 'INTERFACE_NAME',
					},
					success: function (data) {
						if (!$scope.loaded) {
							return;
						}

						updateThroughputGraph((data && data.items && data.items.length > 0) ? data.items[0].rtStatsList : null);
					},
				});
			}

			function clearThroughputGraph() {
				if ($scope.chartsSettings.graphs.length === 2) {
					$scope.chartsSettings.graphs.pop();
					$scope.throughputChart.validateData();
				}
			}

			function updateThroughputGraph(rtStatsList, name) {
				if (!$scope.throughputChart) {
					if ($('#throughput-chart').length < 1) {
						console.log('no throughput div');
					}
					$scope.throughputChart = AmCharts.makeChart('throughput-chart', $scope.chartsSettings);
				}

				if (rtStatsList) {
					var fieldName = 'throughputTotal';
					if (name) {
						fieldName = 'deviceThroughputTotal';
						if ($scope.chartsSettings.graphs.length === 1) {
							$scope.chartsSettings.graphs.push({
								lineThickness: 2,
								dateFormat: 'JJ:NN:SS DD, YYYY',
								fillAlphas: 0.33,
								fontSize: 4,
								id: 'AmGraph-3',
								title: name,
								lineColor: $scope.throughputChart.colors[1],
								valueField: 'deviceThroughputTotal',
								valueAxis: 'ValueAxis-1',
								balloonFunction: function (graphDataItem) {
									return $filter('bits')(graphDataItem.values.value, 1) + 'ps';
								},
							});
						}
						$scope.chartsSettings.graphs[1].title = name;
					}

					if (!$scope.throughputChart.dataProvider || $scope.throughputChart.dataProvider.length !== rtStatsList.length) {
						$scope.throughputChart.dataProvider = rtStatsList;
					}
					var bucket = 0;
					rtStatsList.forEach(function (dataItem) {
						$scope.throughputChart.dataProvider[bucket][fieldName] = (dataItem.throughputReceived || 0) + (dataItem.throughputSent || 0);
						if (rtStatsList && rtStatsList.length > 0 && $scope.throughputChart.dataProvider[0].sampleTime !== rtStatsList[0].sampleTime) {
							$scope.throughputChart.dataProvider[bucket].sampleTime = dataItem.sampleTime;
							$scope.throughputChart.dataProvider[bucket].sampleTimeEnd = dataItem.sampleTimeEnd;
						}
						bucket++;
					});
				} else if (name) {
					if ($scope.chartsSettings.graphs.length === 2) {
						$scope.chartsSettings.graphs.pop();
					}
				}

				$scope.throughputChart.validateData();
				$scope.loaders.traffic = false;
				$scope.$digest();
			}

			function getEntityConnectionStats(pid, type, deviceIds, name) {
				type = $scope.isSite(type) ? 'sites' : 'logins';

				if (timeouts.updateEntityConnectionStatsTimeout) {
					$timeout.cancel(timeouts.updateEntityConnectionStatsTimeout);
				}

				if (!($scope.currentObject.protoId === pid && (type === 'sites' || deviceIds[0] === $scope.currentObject.deviceId))) {
					return;
				}

				setCurrentTimes();

				store.fetch({
					rt: true,
					path: '/getMonitor',
					method: 'POST',
					data: type + '=' + pid,
					skipParsePostData: true,
					queryParams: {
						accountId: $state.params.accountId,
						interval: $scope.accountChartData.intervals,
						fromDate: $scope.accountChartData.from,
						toDate: $scope.accountChartData.to,
						deviceId: $scope.isSite(type)? -1 : (deviceIds[0] || -1),
						mergeDevices: $scope.isSite(type),
						mock: false,
						rtStats: true,
						type: type,
						numberOfSegments: NUMBER_OF_SEGMENTS,
						deviceAggregationType: 'INTERFACE_NAME',
					},
					error: function () {
						$scope.loaders.links = false;
						if (!$scope.loaded) {
							return;
						}
						timeouts.updateEntityConnectionStatsTimeout = $timeout(function () {
							getEntityConnectionStats(pid, type, deviceIds, name);
						}, 1000, false);
					},
					success: function (data) {
						$scope.loaders.links = false;
						if (!$scope.loaded || !($scope.currentObject.protoId === pid && (type === 'sites' || deviceIds[0] === $scope.currentObject.deviceId))) {
							return;
						}

						if (timeouts.updateEntityConnectionStatsTimeout) {
							$timeout.cancel(timeouts.updateEntityConnectionStatsTimeout);
						}

						$scope.linkWidth = $('#inner-iteminfo').width() - 30;
						processLinks(data.items, type);
						updateThroughputGraph((data && data.items) ? $scope.link.rtStatsList : null, name);
						updateInnerItemScroll();
						$scope.$digest();

						timeouts.updateEntityConnectionStatsTimeout = $timeout(function () {
							getEntityConnectionStats(pid, type, deviceIds, name);
						}, 10000, false);
					},
				});
			}



			function setDevice(itemDevice) {
				// Clearing versionName for older versions of different clients (which send wrong data for versionName)
				switch (itemDevice.osType) {
					case 'OS_LINUX':
						itemDevice.clientVersionName = null;
						break;
					case 'OS_IOS':
						if (itemDevice.clientVersionName && itemDevice.clientVersionName.split('.').length <= 2) {
							itemDevice.clientVersionName = null;
						}
						break;
					case 'OS_MAC':
						if (itemDevice.clientVersionName === 'N/A') {
							itemDevice.clientVersionName = null;
						}
						break;
					default:
						break;
				}

				return itemDevice;
			}

			function processLinks(links, type) {
				$scope.link = {};
				$scope.links = {};
				$scope.alternativeWANLinks = [];
				$scope.S2SLinks = [];

				if (!links) {
					return;
				}

				var foundMergedLink = links.filter(function (item) { return item.mergedLink; })[0];

				if (foundMergedLink) {
					$scope.link = foundMergedLink;
					$scope.link.linkId = foundMergedLink.pid + 'mergedLink';
					links.splice(links.indexOf(foundMergedLink), 1);
					if (!$scope.link.rtStatsList) {
						$scope.link.rtStatsList = [];
					}
					if ($scope.link.rtStatsList.length === 0) {
						LinksProcessingService.insertRangeStats($scope.link.rtStatsList, $scope.accountChartData.from, $scope.accountChartData.to)
					}
				} else {
					$scope.link = {
						location: {},
						serverPacketsSent: 0,
						serverPacketsReceived: 0,
						clientPacketsSent: 0,
						clientPacketsReceived: 0,
						rtStatsList: [],
					};
				}

				links.forEach(function (dataItem) {
					if (!dataItem.name && dataItem.site && dataItem.site.interfaceData) {
						var thisLink = dataItem.site.interfaceData.filter(function(linkData) { return linkData.interface_id === dataItem.interfaceName})[0];
						if (thisLink) {
							dataItem.name = thisLink.name;
						}
					}
					if (isAltWanInterface(dataItem.interfaceType)) {
						$scope.alternativeWANLinks.push(setLink(dataItem));
					} else if (dataItem.interfaceType === 'S2S_DEST' || dataItem.protocol === 'S2S_TUNNEL') {
						$scope.S2SLinks.push(setLink(dataItem));
					} else {
						if (!dataItem.mergedLink && ((dataItem.device && dataItem.device.deviceCategory === 'DEVICE_CATEGORY_SOCKET' && (dataItem.interfaceName === '' || dataItem.deviceId === '0')))) {
							console.log("Removed a socket link that doesn't have an interface name or deviceId 0 of socket");
							return;
						}
						if (dataItem.device && (dataItem.connectionState !== 'CONNECTED' || !$scope.currentObject.device)) { // don't use a passive link (CONNECTED state) device because it's empty
							$scope.currentObject.device = setDevice(dataItem.device);
						}
						if (dataItem.socket && (dataItem.connectionState !== 'CONNECTED' || !$scope.currentObject.socket) && dataItem.lastTimeStamp && (!$scope.currentObject.lastTimeStamp || $scope.currentObject.lastTimeStamp < dataItem.lastTimeStamp)) {
							$scope.currentObject.socket = dataItem.socket;
							$scope.currentObject.lastTimeStamp = dataItem.lastTimeStamp;
							if ($scope.currentObject.socket.registrationTime) {
								$scope.currentObject.socket.uptime = moment.duration(new Date().getTime() - $scope.currentObject.socket.registrationTime).humanize();
							} else {
								$scope.currentObject.socket.uptime = null;
							}
						}

						if (type === 'sites') {
							if (!dataItem.rtStatsList || dataItem.rtStatsList.length === 0) {
								dataItem.rtStatsList = [];
								LinksProcessingService.insertRangeStats(dataItem.rtStatsList, $scope.accountChartData.from, $scope.accountChartData.to);
							}
							$scope.links[dataItem.deviceId + dataItem.interfaceName + dataItem.interfaceType] = setLink(dataItem);
							$scope.links[dataItem.deviceId + dataItem.interfaceName + dataItem.interfaceType].rtStatsList = dataItem.rtStatsList;

							LinksProcessingService.mergeLink($scope.links[dataItem.deviceId + dataItem.interfaceName + dataItem.interfaceType], $scope.link);
						} else {
							$scope.link = setLink(links[0]);
							$scope.link.rtStatsList = links[0].rtStatsList;
							if ($scope.link.rtStatsList.length === 0) {
								LinksProcessingService.insertRangeStats($scope.link.rtStatsList, $scope.accountChartData.from, $scope.accountChartData.to);
							}
						}
					}
				});

				if (links && links.length - $scope.alternativeWANLinks.length > 0 - $scope.S2SLinks.length > 0) {
					$scope.link.linksCount = links.length - $scope.alternativeWANLinks.length - $scope.S2SLinks.length;
				} else {
					$scope.link.rtStatsList = [];
					LinksProcessingService.insertRangeStats($scope.link.rtStatsList, $scope.accountChartData.from, $scope.accountChartData.to);
					$scope.link.linksCount = 0;
				}
			}

			function setCurrentTimes() {
				var toDate = new Date();
				toDate.setSeconds(0);
				toDate.setMilliseconds(0);
				toDate = toDate.getTime();
				var fromDate = toDate - STATS_LAST_TIMESPAN; // Last 24 hours

				$scope.accountChartData.to = toDate;
				$scope.accountChartData.from = fromDate;

				$scope.accountChartData.intervals = Math.floor(($scope.accountChartData.to - $scope.accountChartData.from) / RT_STATS_INTERVALS_COUNT);
				if ($scope.accountChartData.intervals < (MIN_STATS_INTERVAL)) {
					$scope.accountChartData.intervals = MIN_STATS_INTERVAL;
				}
			}

			function getAccountStats() {
				setCurrentTimes();
				getAccountTrafficData();
				getAppsData(null, $scope.accountChartData.from, $scope.accountChartData.to);
			}

			function getTreeRoot() {
				return [
					{
						id: 'root',
						level: -1,
						name: '',
						data: {
							$dim: 0,
							throughput: 0,
							type: 'root',
							$type: 'transparent',
							members: {},
						},
						adjacencies: [],
						children: [],
					}];
			}


			function getTree() {
				treeData = getTreeRoot();

				getAccountTopologyData(true);
			}

			function getAccountTopologyData(treeCall) {
				store.fetch({
					path: 'getAccountTopologyData',
					queryParams: { accountId: $state.params.accountId },
					success: function (data) {
						if (!$scope.loaded || !data) {
							return;
						}

						account = _.cloneDeep(data.account);

						if (treeCall) {
							$scope.currentObject = account;
							$scope.currentObject.data = data.account;
							$scope.currentObject.data.uniqueIdentifier = 'account_' + account.id;  // for editor
						}

						$scope.accountDetails = data.account;
						$scope.accountDetails.enabledBladesCount = getEnabledBladesCount();
						$scope.accountDetails.bladesNum = ($scope.$root.useNewFW ? 2 : 3) + ($scope.accountDetails.avConfigurationLicensed | 0) + ($scope.accountDetails.ngAvConfigurationLicensed | 0) + ($scope.accountDetails.ipsConfigurationLicensed | 0);
						$scope.orig = account;

						$scope.$digest();
					},
				});
			}

			function getPops() {
				refreshPops = false;
				store.fetch({
					rt: true,
					path: '/getPops',
					queryParams: {
						accountId: $state.params.accountId,
						min: 1,
						require: requiredPops.toString(),
					},
					success: function (data) {
						if (!$scope.loaded) {
							return;
						}
						if (!data || Object.keys(data).length === 0) {
							console.log('no pops received');
						} else {
							pops = data;
							processPops(pops);
						}
					},
				});
			}

			function showNotification(type, message) {
				$scope.$root.showNotification(type, message, message, true, true);
				hideLoader();
				document.getElementById('infovis').style.opacity = 0.3;
			}

			function hideNotificaiton() {
				document.getElementById('infovis').style.opacity = 1;
				$scope.$root.hideNotification();
			}

			/*
			 get new data from server,
			 forceDBFetch - force a db fetch
			 redraw - force a redraw of the rgraph after the next fetch of data
			 */
			function getNewData(forceDBFetch, redraw) {
				var sites = '';
				var logins = '';

				if (updateCounter === DB_FETCH_INTERVAL) {
					updateCounter = 0;
				} else {
					sites = $scope.topologyDetails.sites.pids.toString();
					logins = $scope.topologyDetails.users.pids.toString();
				}

				var sitesAndLoginToFetch = '';
				if (sites !== '') {
					sitesAndLoginToFetch = 'sites=' + sites;
					if (logins !== '') {
						sitesAndLoginToFetch += '&logins=' + logins;
					}
				} else if (logins !== '') {
					sitesAndLoginToFetch = 'logins=' + logins;
				}

				store.fetch({
					rt: true,
					path: '/getTopology',
					method: 'POST',
					data: sitesAndLoginToFetch,
					skipParsePostData: true,
					queryParams: {
						accountId: $state.params.accountId,
						dbFetch: forceDBFetch || updateCounter === 0,
						interval: MIN_STATS_INTERVAL,
						fromDate: $scope.accountChartData.from,
						toDate: $scope.accountChartData.to,
						mock: false,
						deviceAggregationType: 'INTERFACE_NAME',
						deviceId: -1,
					},
					error: function () {
						if (!$scope.loaded) {
							return;
						}
						updateCounter++;
						timeouts.updateTimeout = $timeout(updateData, 2000, false);
					},
					success: function (data) {
						if (timeouts.updateTimeout) {
							$timeout.cancel(timeouts.updateTimeout);
						}
						if (!$scope.loaded) {
							return;
						}

						foundAccount = data.foundAccount;
						min_users_to_group = (data.minUsersToGroup || data.minUsersToGroup === 0) ? data.minUsersToGroup : min_users_to_group;
						if (foundAccount) {
							if (noDataCounter >= 30) {
								hideNotificaiton();
							}
							noDataCounter = 0;
						} else {
							noDataCounter++;
							if (noDataCounter === 30) {
								if ($('.ngn').css('display') !== 'block') {
									showNotification('error', 'Temporary problem');
								}
							}
						}

						$scope.topologyDetails.sites = { online: [], pids: [] };
						$scope.topologyDetails.users = { online: [], pids: [] };

						if (updateCounter === 0) {
							setRootThroughput(0);
						}

						// for testing
						if (TEST_MANY_USERS) {
							var dataToDuplicate = data.items.filter(function (da) { return da.pid<1000000000 && da.status === 'up'; })[0];
							if (dataToDuplicate) {
								for (var i = 0; i < 150; i++) {
									var newData = angular.copy(dataToDuplicate);
									newData.pid += i;
									newData.login ={name: 'test login' + i};
									data.items.push(newData);
								}
							} else {
								console.log('Need at least one connected user to duplicate');
							}
						}

						// set groupingUsers flag mode
						groupingUsers = data && data.items && data.items.filter(function (da) { return da.pid<1000000000 && da.status === 'up'; }).length >= min_users_to_group;

						if (!rgraph || redraw) {
							drawRgraph(data.items, redraw);
						}

						processNodes(data.items);
						refreshNodes(treeData, foundAccount);

						setDropDownEntities(data.items);

						lastUpdated = new Date();
						$scope.$root.lastUpdatedMiliseconds = new Date().getTime() - lastUpdated.getTime();

						if (refreshPops) {
							getPops();
						}
						updateCounter++;
					},
				});
			}


			function setDropDownEntities(items) {
				items = items || [];
				$scope.$apply(function () {
					var currentSite,
						currentUser,
						dataItem;

					if (!$scope.sites) {
						$scope.sites = [];
					}
					if (!$scope.users) {
						$scope.users = [];
					}

					items.forEach(function (item) {
						if (item.devices) {
							item.devices = [];
						}
					});

					items.forEach(function (item) {
						if ($scope.topologyDetails.sites.pids.indexOf(item.pid) >= 0) {
							currentSite = _.findWhere($scope.sites, { pid: item.pid });

							if (currentSite) {

							} else {
								dataItem = item.site || {};
								dataItem.devices = [];
								dataItem.pid = item.pid;

								$scope.sites.push(dataItem);
								currentSite = $scope.sites[$scope.sites.length - 1];
							}

							if (item.status === 'up') {
								currentSite.up = true;
							}
						} else {
							currentUser = _.findWhere($scope.users, { pid: item.pid });

							if (currentUser) {

							} else {
								dataItem = item.login || {};
								dataItem.devices = [];
								dataItem.pid = item.pid;

								$scope.users.push(dataItem);

								currentUser = $scope.users[$scope.users.length - 1];
							}

							if (item.status === 'up') {
								currentUser.up = true;
								var currentDevice = _.findWhere(currentUser.devices, { id: item.deviceId });
								if (!currentDevice) {
									var newDevice = item.device || {};
									newDevice.id = item.deviceId;
									currentUser.devices.push(newDevice);
								}
							} else {
								currentUser.up = false;
							}
						}
					});
				});

			}

			function setRootThroughput(newThroughput) {
				treeData[0].data.throughput = newThroughput;
				if ($scope.currentObject && $scope.currentObject.type === 'ACCOUNT') {
					$scope.currentObject.throughput = newThroughput;
				}
			}

			function updateLastUpdate() {
				if (!$scope.loaded) {
					return;
				}

				if (lastUpdated) {
					$scope.$root.lastUpdatedMiliseconds = new Date().getTime() - lastUpdated.getTime();
				}

				timeouts.updateLastUpdateTimeout = $timeout(updateLastUpdate, 1000);
			}

			function processPops(newPops) {
				if (newPops) {
					for (var popId in newPops) {
						addPop(popId, true);
					}
				}
			}

			function addPop(newPop, noRefresh, noAddToTree) {
				var intPop = parseInt(newPop, 10);
				if (popIds.indexOf(intPop) > -1) {
					if (!noRefresh && (!pops[intPop] || !pops[intPop].name)) {
						if (requiredPops.indexOf(intPop) === -1) {
							requiredPops.push(intPop);
						}
						refreshPops = true;
					}
					return;
				}
				popIds.push(intPop);

				if (noAddToTree) {
					popsStashedForGrouping.push(intPop);
					return;
				}

				createPopNode(newPop, noRefresh);
			}

			function createPopNode(newPop, noRefresh) {
				var popName;
				if (pops[newPop] && pops[newPop].name) {
					popName = pops[newPop].name;
				} else if (!noRefresh) {
					refreshPops = true;
				}

				var adjs = [];
				popIds.forEach(function (innerPopid) {
					if (innerPopid !== newPop) {
						var popNode = _.findWhere(treeData, { id: 'pop' + innerPopid });
						if (popNode) {
							adjs.push({
								nodeTo: 'pop' + innerPopid,
								data: {
									weight: 10,
									type: 'pop',
									popId: innerPopid,
								},
							});

							_.findWhere(treeData, { id: 'pop' + innerPopid }).adjacencies.push({
								nodeTo: 'pop' + newPop,
								data: {
									weight: 10,
									type: 'pop',
									popId: newPop,
								},
							});
						}
					}
				});

				var newPopNode = {
					id: 'pop' + newPop,
					name: popName || DEFAULT_POP_NAME,
					data: {
						$color: ONLINE_COLOR,
						$type: 'pop',
						up: true,
						$dim: POP_SIZE,
						type: 'pop',
						weight: 10,
						visible: true,
					},
					adjacencies: adjs,
					children: [],
				};

				treeData[0].adjacencies.push({
					nodeTo: 'pop' + newPop,
					data: {
						weight: 10,
					},
				});

				treeData.push(newPopNode);
			}

			function removeNode(nodeId) {
				var currentNode;
				var nodeToRemove = _.findWhere(treeData, { id: nodeId });
				if (!nodeToRemove) {
					return;
				}
				for (var i = 1; treeData[i]; i++) {
					currentNode = treeData[i];
					if (currentNode.adjacencies.length > 0) {
						for (var k = 0; currentNode.adjacencies[k]; k++) {
							if (currentNode.adjacencies[k].nodeTo === nodeId || currentNode.adjacencies[k].nodeFrom === nodeId) {
								currentNode.adjacencies.splice(k, 1);
								if (currentNode.data.type === 'groupnode') {
									if (currentNode.adjacencies.length === 0) {
										removeNode(currentNode.id);
									} else if (nodeToRemove.data.pid || nodeToRemove.data.pid == 0) {
										if (nodeToRemove.data.throughput) {
											currentNode.data.throughput -= nodeToRemove.data.throughput;
											treeData[0].data.throughput -= nodeToRemove.data.throughput;
										}
										if (currentNode.data.logins[nodeId]) {
											delete currentNode.data.logins[nodeId];
										}
									}
								}
							}
						}
					}
				}
				if (nodeToRemove.data.pid || nodeToRemove.data.pid == 0) {
					setMaxBandwidth(nodeToRemove.id, 0);
				}

				treeData.splice(treeData.indexOf(nodeToRemove), 1);
			}

			function processNodes(data) {
				if (!$scope.loaded) {
					return;
				}
				if (!rgraph || !treeData) {
					timeouts.processNodesTimeout = $timeout(function () {
						processNodes(data);
					}, 50, false);
					return;
				}

				clearOldData();
				addNewNodes(data);
				updateExistingNodes(data);
				$scope.$digest();
			}

			function clearOldData() {
				if (!treeData) return;

				for (var node in treeData) {
					var currentNode = treeData[node];
					if (currentNode.rootType === 'site' || currentNode.rootType === 'login') {
						currentNode.data.throughput = 0;
						currentNode.data.distance = 0;
						if (currentNode.rootType === 'site') {
							currentNode.deviceIds = [];
						}
					}

				}
			}

			function updateNode(currentNode, dataObject, addToTree) {
				var objectType = currentNode.data.type;
				var popIdInt;

				if (dataObject.popId || dataObject.popId === 0) {
					popIdInt = parseInt(dataObject.popId, 10);
					if (requiredPops.indexOf(popIdInt) === -1) {
						requiredPops.push(popIdInt);
					}
					addPop(dataObject.popId, false, !!currentNode.data.logins);
				}

				if (!(currentNode.data.popId || currentNode.data.popId == 0)) {
					if (dataObject.popId) {
						currentNode.data.popId = dataObject.popId;
					} else if ($scope.isSite(objectType)) {
						currentNode.data.popId = Math.ceil(Math.random() * (pops.length || MIN_NODES));
						if (requiredPops.indexOf(currentNode.data.popId) === -1) {
							requiredPops.push(currentNode.data.popId);
						}
						addPop(currentNode.data.popId, false, !!currentNode.data.logins);
					}
				}

				var currentPop = _.findWhere(treeData, { id: 'pop' + currentNode.data.popId });
				if (currentPop && currentPop.name === DEFAULT_POP_NAME && pops[currentNode.data.popId] && pops[currentNode.data.popId].name) {
					currentPop.name = pops[currentNode.data.popId].name;
				}


				if ((dataObject.popId || dataObject.popId == 0) && currentNode.data.popId !== dataObject.popId) {
					if ($scope.isSite(objectType) || dataObject.deviceId === currentNode.data.deviceId) {
						var mainPop;
						if (!$scope.isSite(objectType)) {
							mainPop = currentPop;
							currentPop = _.findWhere(treeData, { id: 'pop' + currentNode.data.popId + '_logins' });
						}

						for (var i = 0; currentPop.adjacencies[i]; i++) {
							if (currentPop.adjacencies[i].nodeTo === currentNode.id) {
								currentPop.adjacencies.splice(i, 1);
								if (mainPop && currentPop.adjacencies.length === 0) {
									for (var k = 0; mainPop.adjacencies[k]; k++) {
										if (mainPop.adjacencies[k].nodeTo === currentPop.id) {
											mainPop.adjacencies.splice(k, 1);
											break;
										}
									}
									for (var l = 0; treeData[l]; l++) {
										if (treeData[l].id === currentPop.id) {
											treeData.splice(l, 1);
											break;
										}
									}
								}
								break;
							}
						}

						if (useTunnelToOverwritePopInfo(currentNode,dataObject)){
							currentNode.data.popId = dataObject.popId;
							currentNode.data.routeMetric = dataObject.routeMetric;
							currentNode.data.haRole = dataObject.haRole;
							currentPop = _.findWhere(treeData, { id: 'pop' + dataObject.popId });
						}
					}
				}



				if (currentPop && currentPop.data.up) {
					if ($scope.isLogin(objectType) && !currentNode.data.logins) {
						var loginsNode = _.findWhere(treeData, { id: 'pop' + currentNode.data.popId + '_logins' });
						if (loginsNode) {
							if (dataObject.throughput || dataObject.throughput === 0) {
								if (loginsNode.data.logins[currentNode.id]) {
									loginsNode.data.throughput -= loginsNode.data.logins[currentNode.id];
								}
								loginsNode.data.throughput += dataObject.throughput;
							}
							loginsNode.data.logins[currentNode.id] = dataObject.throughput || 0;

							currentPop = loginsNode;
						} else {
							var newNode = {
								id: 'pop' + dataObject.popId + '_logins',
								name: '',
								data: {
									$angularWidth: 0.001,
									$span: 0.001,
									$type: 'circle',
									$color: ONLINE_COLOR,
									$dim: 0.01,
									type: 'groupnode',
									throughput: dataObject.throughput ? dataObject.throughput : 0,
									logins: {},
									up: true,
								},
								adjacencies: [],
								children: [],
							};

							newNode.data.logins[currentNode.id] = dataObject.throughput || 0;
							treeData.push(newNode);
							currentPop.adjacencies.push({
								nodeTo: newNode.id,
								data: {
									weight: 0,
									index: newNode.id + '_' + currentPop.id,
								},
							});
							currentPop = newNode;
						}
						setMaxBandwidth(currentPop.id, currentPop.data.throughput || 0);
					}

					if (!(isAltWanInterface(dataObject.interfaceType) || dataObject.interfaceType === 'S2S_DEST')) {
						currentNode.data.up = dataObject.status === 'up';
						currentNode.data.throughput += dataObject.throughput || 0;
						currentNode.data.packetLossUp = dataObject.packetLossUp;
						currentNode.data.packetLossDown = dataObject.packetLossDown;
						currentNode.data.averagePacketLossUp = dataObject.averagePacketLossUp;
						currentNode.data.averagePacketLossDown = dataObject.averagePacketLossDown;
						currentNode.data.distance = Math.max(currentNode.data.distance || 0, dataObject.distance || 0);
						currentNode.data.uptime = dataObject.uptime;
						currentNode.data.externalIP = dataObject.externalIP;
						currentNode.data.location = dataObject.location;
						if (dataObject.deviceId || dataObject.deviceId === 0) {
							if (currentNode.data.deviceIds.indexOf(dataObject.deviceId) === -1) {
								currentNode.data.deviceIds.push(dataObject.deviceId);
							}
						}
						if (dataObject.device) {
							currentNode.data.device = setDevice(dataObject.device);
						}
						if (dataObject.socket) {
							currentNode.data.socket = dataObject.socket;
						}
						currentNode.data.lastLogin = dataObject.lastLogin;
						currentNode.data.physicalPort = dataObject.physicalPort;

						if (!$scope.isLogin(objectType)) {
							setMaxBandwidth(currentNode.id, currentNode.data.throughput || 0);
						}
					}

					if (!_.findWhere(currentPop.adjacencies, { nodeTo: currentNode.id })) {
						currentPop.adjacencies.push({
							nodeTo: currentNode.id,
							data: {
								epsilon: 3,
								weight: 0,
								index: currentNode.id,
							},
						});
					}
				}
			}

			function useTunnelToOverwritePopInfo(currentNode, dataObject){
				//the tunnel with the lowest routeMetric is the active one
				var checkRouteMetric = typeof currentNode.data.routeMetric === 'undefined' || currentNode.data.routeMetric >= dataObject.routeMetric;
				//prefer by the following order MASTER, no HA role, BACKUP
				var checkMasterDevice = dataObject.haRole === 'MASTER' || (currentNode.data.haRole !== 'MASTER' &&  typeof dataObject.haRole === 'undefined') || typeof currentNode.data.haRole === 'undefined';
				return checkRouteMetric && checkMasterDevice;
			}

			function setMaxBandwidth(id, newThroughput) {
				treeData[0].data.members[id] = newThroughput;
				setRootThroughput(_.sum(treeData[0].data.members));
			}

			function getNode(dataObject, usersGroup) {
				for (var i = 0; treeData[i]; i++) {
					if (usersGroup) {
						if (treeData[i].id === loginsGroupId) {
							return (treeData[i]);
						}
					}
					if ($scope.isSite(treeData[i].data.type)) {
						if (treeData[i].id === dataObject.pid) {
							return (treeData[i]);
						}
					} else if ($scope.isLogin(treeData[i].data.type)) {
						if (treeData[i].id === dataObject.pid + '_' + dataObject.deviceId) {
							return (treeData[i]);
						}
					}
				}
			}

			function addNewNodes(data) {
				if (data && data.length > 0) {
					if (!groupingUsers && popsStashedForGrouping.length > 0) {
						popsStashedForGrouping.forEach(function(pop) {
							createPopNode(pop);
						});
						popsStashedForGrouping = [];
					}

					if (!groupingUsers) {
						removeNode(loginsGroupId);
					}

					data.forEach(function (dataObject) {
						var objectType;
						var pid = dataObject.pid;
						var currentNode = getNode(dataObject, groupingUsers);
						var targetId = pid;
						if (dataObject.site) {
							updateData.dbData[pid] = dataObject.site;
						} else if (dataObject.login) {
							updateData.dbData[pid] = dataObject.login;
						}

						if (updateData.dbData[pid]) {
							if (updateData.dbData[pid].type === 'SITE') {
								objectType = 'site';
								dataObject.site = updateData.dbData[pid];
							} else if (updateData.dbData[pid].type === 'ACCESSLOGIN') {
								objectType = 'login';
								dataObject.login = updateData.dbData[pid];
								if (dataObject.deviceId) {
									targetId = targetId + '_' + dataObject.deviceId;
								}
							}

							var addToTree = $scope.isSite(objectType) || (dataObject.status === 'up' && !groupingUsers);
							if (currentNode) {
								objectType = currentNode.data.type;
								if (groupingUsers && objectType === 'login' && dataObject.status === 'up' && currentNode.data.logins) {
									currentNode.data.logins[targetId] = dataObject;
								}
							} else {
								if ($rootScope?.tags?.indexOf('DEMO') >= 0 && $scope.isSite(objectType)) {
									dataObject.status = 'up';
								}

								if (addToTree) {
									currentNode = addNode(dataObject[objectType].name, dataObject.status === 'up' || $rootScope?.tags?.indexOf('DEMO') >= 0, targetId, dataObject, objectType);
									treeData.push(currentNode);
								} else if (dataObject.status === 'up') {
									targetId = loginsGroupId;
									var loginsObj = {};
									loginsObj[dataObject.pid + '_' + dataObject.deviceId] = dataObject;
									currentNode = addNode("VPN Devices", true, targetId, {data: {}, login: {}, logins: loginsObj}, "login");
									treeData.push(currentNode);
									$scope.refreshLogins = new Date().getTime();
									addToTree = true;
								}
							}

							updateConnectedCounts(objectType, dataObject.status === 'up', pid);
							if (currentNode && addToTree) {
								updateNode(currentNode, dataObject, addToTree);
							}
						}
					});
				}
			}

			function updateConnectedCounts(type, online, pid, updateType) {
				if ($scope.isSite(type) && (pid || pid === 0)) {
					if (updateType !== 'connected' && $scope.topologyDetails.sites.pids.indexOf(pid) === -1) {
						$scope.topologyDetails.sites.pids.push(pid);
					}
					if (updateType !== 'count' && online) {
						if ($scope.topologyDetails.sites.online.indexOf(pid) === -1) {
							$scope.topologyDetails.sites.online.push(pid);
						}
					}
				} else if ($scope.isLogin(type) && (pid || pid === 0)) {
					if (updateType !== 'connected' && $scope.topologyDetails.users.pids.indexOf(pid) === -1) {
						$scope.topologyDetails.users.pids.push(pid);
					}

					if (updateType !== 'count' && online) {
						if ($scope.topologyDetails.users.online.indexOf(pid) === -1) {
							$scope.topologyDetails.users.online.push(pid);
						}
					}
				}
			}

			function updateExistingNodes(data) {
				for (var node in treeData) {
					var currentNode = treeData[node];
					var objectType = currentNode.data.type;
					if (currentNode.rootType === 'site' || currentNode.rootType === 'login') {
						var i,
							found = false;

						updateConnectedCounts(objectType, false, currentNode.data.pid, 'count');

						if (currentNode.id !== loginsGroupId) {
							if (currentNode.data && currentNode.data.data.interfaceData) {
								if (currentNode.data.data.interfaceData.filter(function (item) { return isAltWanInterface(item.interfaceType); }).length > 0) {
									currentNode.data.alternativeWAN = {};
								} else {
									currentNode.data.data.alternativeWAN = null;
								}
								if (currentNode.data.data.interfaceData.filter(function (item) { return item.s2sEnabled; }).length > 0) {
									currentNode.data.S2S = {};
								} else {
									currentNode.data.data.S2S = null;
								}
							} else {
								currentNode.data.data.alternativeWAN = null;
								currentNode.data.data.S2S = null;
							}
						}
						currentNode.data.throughput = 0;
						currentNode.data.distance = 0;

						if (data) {
							for (i = 0; data[i]; i++) {
								var dataObject = data[i];
								if (currentNode.id === loginsGroupId && dataObject.type === 'login') {
									found = true;
									var targetId = dataObject.pid;
									if (dataObject.deviceId) {
										targetId = targetId + '_' + dataObject.deviceId;
									}
									if (dataObject.status === 'up') {
										dataObject.uptime = moment.duration(dataObject.uptime).humanize();
										currentNode.data.logins[targetId] = dataObject;
									} else if (currentNode.data.logins[targetId]) {
										delete currentNode.data.logins[targetId];
									}

									updateNode(currentNode, dataObject, true);
								} else if (dataObject.pid === currentNode.data.pid) {
									if (dataObject.type === 'login' && groupingUsers) {
										// remove node (found == false)
									} else {
									    // ALTERNATIVE is sent only on one device, so even if the currentNode shows secondary, update the ALT WAN status.
									    if (isAltWanInterface(dataObject.interfaceType)) {
											currentNode.data.alternativeWAN = { online: true, throughput: dataObject.throughput || 0 };
										}
										if (currentNode.data.deviceId) {
											if (currentNode.data.deviceId !== dataObject.deviceId || !(dataObject.popId || dataObject.popId == 0)) {
												continue;
											}
										} else {
											currentNode.data.deviceId = dataObject.deviceId;
										}

										if ($rootScope?.tags?.indexOf('DEMO') >= 0) {
											dataObject.status = 'up';
										}

										if (dataObject.status !== 'up') {
											if (currentNode.rootType === 'login') {
												break;
											}

											i = data.length;
										}

										currentNode.data.uptime = dataObject.uptime;

										if (dataObject.interfaceType === 'S2S_DEST') {
											currentNode.data.S2S = { online: true, throughput: dataObject.throughput || 0 };
										}

										if (currentNode.rootType === 'login') {
											if (dataObject.login) {
												currentNode.data.data = dataObject.login;
											}
										} else if (dataObject.site) {
											currentNode.data.data = dataObject.site;
										}
										var addToTree = $scope.isSite(objectType) && (dataObject.status === 'up' && !groupingUsers);
										updateNode(currentNode, dataObject, addToTree);
										found = true;
									}
								}
							}
						}

						if (found) {
							// updateConnectedCounts(objectType, true, treeData[node].data.pid, "connected"); //FOR DISPLAY
							updateConnectedCounts(objectType, dataObject.status === 'up', currentNode.data.pid, 'connected');
						} else {
							updateConnectedCounts(objectType, false, currentNode.data.pid, 'connected');
							currentNode.data.up = false;
							currentNode.data.throughput = 0;
							currentNode.data.disatance = 0;
							if ($scope.isSite(objectType)) {
								$scope.currentObject.up = false;
								$scope.currentObject.throughput = 0;
								$scope.currentObject.disatance = 0;
							} else {
								if (currentNode.data.pid === $scope.currentObject.protoId) {
									unSelectNode(currentNode.data);
								}
								removeNode(currentNode.id);
							}
						}

						if ($scope.currentObject && Object.keys($scope.currentObject).length !== 0 && ($scope.currentObject.protoId || $scope.currentObject.protoId === 0) &&
							currentNode.data.pid === $scope.currentObject.protoId && (currentNode.rootType === 'site' || $scope.currentObject.deviceId === currentNode.data.deviceId)) {
							if (currentNode.rootType === 'login' && !currentNode.data.up) {
								currentNode.data.color = '';
								$scope.currentObject = {};
							} else {
								if (!isAltWanInterface(currentNode.data.interfaceType) && currentNode.data.interfaceType !== 'S2S_DEST') {
									currentNode.data.color = ONLINE_COLOR;
									$scope.currentObject.up = currentNode.data.up;
									$scope.currentObject.throughput = currentNode.data.throughput;
									$scope.currentObject.packetLossUp = currentNode.data.packetLossUp;
									$scope.currentObject.packetLossDown = currentNode.data.packetLossDown;
									$scope.currentObject.averagePacketLossUp = currentNode.data.averagePacketLossUp;
									$scope.currentObject.averagePacketLossDown = currentNode.data.averagePacketLossDown;
									$scope.currentObject.distance = currentNode.data.distance;
									$scope.currentObject.externalIP = currentNode.data.externalIP;
									$scope.currentObject.location = currentNode.data.location;
									$scope.currentObject.link = currentNode.data.link;
									$scope.currentObject.pop = pops[currentNode.data.popId] ? pops[currentNode.data.popId] : { name: DEFAULT_POP_NAME };
									$scope.currentObject.uptime = moment.duration(currentNode.data.uptime).humanize();
									if (currentNode.data.device) {
										$scope.currentObject.device = setDevice(currentNode.data.device);
									}
									if (currentNode.data.socket && currentNode.data.lastTimeStamp && (!$scope.currentObject.lastTimeStamp ||  $scope.currentObject.lastTimeStamp < currentNode.data.lastTimeStamp)){
										$scope.currentObject.socket = currentNode.data.socket;
										$scope.currentObject.lastTimeStamp = currentNode.data.lastTimeStamp;
										if ($scope.currentObject.socket.registrationTime) {
											$scope.currentObject.socket.uptime = moment.duration(new Date().getTime() - $scope.currentObject.socket.registrationTime).humanize();
										} else {
											$scope.currentObject.socket.uptime = null;
										}
									}

									$scope.currentObject.lastLogin = currentNode.data.lastLogin;
									$scope.currentObject.physicalPort = currentNode.data.physicalPort;
									$scope.currentObject.multiTunnelMode = currentNode.data.data.multiTunnelMode;
									$scope.currentObject.status = getCurrentStatus($scope.currentObject);
								}

								$scope.currentObject.alternativeWAN = currentNode.data.alternativeWAN;
								$scope.currentObject.S2S = currentNode.data.S2S;
							}
						} else {
							if (currentNode.id === loginsGroupId && $scope.currentObject && $scope.currentObject.logins) {
								$scope.refreshLogins = new Date().getTime();
							} else {
								currentNode.data.color = '';
							}
						}
					}
				}
			}

			function createNode(name, targetId, dataObject, objectType) {
				var internalIp = [];
				dataObject.data = dataObject[objectType];
				var objectRootType = objectType;

				if (objectRootType === 'site') {
					if (dataObject[objectType]) {
						internalIp = dataObject[objectType].globalRange;
					}
					objectType += (dataObject[objectType].siteType || '');
				} else {
					internalIp.push(dataObject.internalIP);
					if (dataObject.device) {
						var newObjectType = objectType;
						if (dataObject.device.deviceCategory && $scope.deviceCategory[dataObject.device.deviceCategory]) {
							newObjectType += dataObject.device.deviceCategory;
						}
						if (dataObject.device.osType && $scope.os[dataObject.device.osType]) {
							newObjectType += dataObject.device.osType;
						}
						if (icons[newObjectType]) {
							objectType = newObjectType;
						}
					}
				}

				if ($rootScope?.tags?.indexOf('DEMO') >= 0) {
					dataObject.popId = dataObject.popId || 1;
				}

				if (dataObject.popId || dataObject.popId == 0) {
					addPop(dataObject.popId, false, targetId === loginsGroupId);
				}

				return {
					id: targetId,
					name: name,
					popId: dataObject.popId,
					rootType: objectRootType,
					data: {
						$type: objectType,
						$dim: objectRootType === 'site' ? (dataObject.site.siteType === 'HEADQUARTERS' ? SITE_SIZE + 10 : SITE_SIZE) : LOGIN_SIZE,
						type: objectType,
						rootType: objectRootType,
						deviceId: dataObject.deviceId,
						deviceIds: dataObject.deviceId || dataObject.deviceId === 0 ? [dataObject.deviceId] : [],
						ip: internalIp,
						externalIP: dataObject.externalIP,
						location: dataObject.location,
						data: dataObject.data,
						popId: targetId === loginsGroupId ? (requiredPops[0] || 1) : dataObject.popId,
						pid: dataObject.pid,
						device: dataObject.device,
						socket: dataObject.socket,
						logins: dataObject.logins,
					},
					adjacencies: [],
					children: [],
				};
			}

			function setNewNodeCurrents(newNode, dataObject, up) {
				var alternativeWAN, S2S;
				if (isAltWanInterface(dataObject.interfaceType)) {
					alternativeWAN = { online: true };
				} else if (dataObject.interfaceType === 'S2S_DEST') {
					S2S = { online: true };
				} else {
					if (dataObject.data.interfaceData) {
						if (dataObject.data.interfaceData.filter(function (item) { return isAltWanInterface(item.interfaceType); }).length > 0) {
							alternativeWAN = {};
						}
						if (dataObject.data.interfaceData.filter(function (item) { return item.s2sEnabled; }).length > 0) {
							S2S = {};
						}

					}
					newNode.data.throughput = dataObject.throughput || 0;
					newNode.data.up = up;
					newNode.data.uptime = dataObject.uptime;
					newNode.data.packetLossUp = dataObject.packetLossUp;
					newNode.data.packetLossDown = dataObject.packetLossDown;
					newNode.data.averagePacketLossUp = dataObject.averagePacketLossUp;
					newNode.data.averagePacketLossDown = dataObject.averagePacketLossDown;
					newNode.data.distance = dataObject.distance || 0;
					newNode.data.lastLogin = dataObject.lastLogin;
					newNode.data.rtStatsList = dataObject.rtStatsList;
					// newNode.data.link = setLink(dataObject);
					newNode.data.physicalPort = dataObject.physicalPort;
				}

				newNode.data.alternativeWAN = alternativeWAN;
				newNode.data.S2S = S2S;
			}

			function addNode(name, up, targetId, dataObject, objectType) {
				var newNode = createNode(name, targetId, dataObject, objectType);
				if (targetId !== loginsGroupId) {
					setNewNodeCurrents(newNode, dataObject, up);
				}

				return newNode;
			}

			function setLink(dataObject) {
				dataObject.linkId = dataObject.deviceId + dataObject.interfaceName + dataObject.interfaceType;
				return dataObject;
			}

			/**
			 * returns the status according to the inputs type the returned data
			 * is from the stored db data
			 **/
			function getCurrentStatus(dataObject) {
				if (dataObject.rootType == 'login' || dataObject.rootType == 'site') {
					if (dataObject.logins) {
						return 'up';
					}
					return updateData.dbData[$scope.currentObject.protoId].status;
				}
			}

			function updateCurrentNode(dataObject, full) {
				var fetchedHosts = $scope.currentObject ? $scope.currentObject.fetchedHosts : null;
				$scope.currentObject = dataObject;
				$scope.currentObject.fetchedHosts = fetchedHosts;
				$scope.currentObject.id = dataObject.data.id;
				$scope.currentObject.data.uniqueIdentifier = $scope.currentObject.type + '_' + $scope.currentObject.id;  // for editor (unique per all object types)
				$scope.currentObject.name = dataObject.data.name;
				$scope.currentObject.email = dataObject.data.email;
				$scope.currentObject.up = dataObject.up;
				$scope.currentObject.protoId = dataObject.pid;
				$scope.currentObject.throughput = dataObject.throughput;
				$scope.currentObject.deviceId = dataObject.deviceId;
				$scope.currentObject.deviceIds = dataObject.deviceIds;
				$scope.currentObject.device = dataObject.device || {};
				$scope.currentObject.socket = dataObject.socket;
				$scope.currentObject.multiTunnelMode = dataObject.data.multiTunnelMode;

				$scope.currentObject.alternativeWAN = dataObject.alternativeWAN;
				$scope.currentObject.alternativeWANOnline = dataObject.alternativeWANOnline;
				$scope.currentObject.alternativeWANConfigured = dataObject.data.alternativeWAN;

				$scope.currentObject.S2S = dataObject.S2S;
				$scope.currentObject.S2SOnline = dataObject.S2SOnline;
				$scope.currentObject.S2SConfigured = dataObject.data.S2S;

				$scope.currentObject.status = getCurrentStatus($scope.currentObject);

				$scope.currentObject.distance = dataObject.distance;
				$scope.currentObject.packetLossUp = dataObject.packetLossUp;
				$scope.currentObject.packetLossDown = dataObject.packetLossDown;
				$scope.currentObject.averagePacketLossUp = dataObject.averagePacketLossUp;
				$scope.currentObject.averagePacketLossDown = dataObject.averagePacketLossDown;

				$scope.currentObject.ip = dataObject.ip;

				if (full) {
					$scope.fetchhosts = new Date().getTime();
					$scope.currentObject.fetchedHosts = false;
					$scope.link = {};
					$scope.links = {};
					$scope.expandedLinks = false;
					$scope.link.rtStatsList = [];
					$scope.link.internalIP = dataObject.ip;
				}


				if ($scope.currentObject.device.deviceCategory === 'DEVICE_CATEGORY_SOCKET') {
					if ($scope.currentObject.socket.registrationTime) {
						$scope.currentObject.socket.uptime = moment.duration(new Date().getTime() - $scope.currentObject.socket.registrationTime).humanize();
					}

					if ($scope.link.maxBandwidthReceived && $scope.link.maxBandwidthSent) {
						$scope.link.bandwidth = '(' + ($scope.link.maxBandwidthReceived / 1000).toFixed(1) + 'Mb/' + ($scope.link.maxBandwidthSent / 1000).toFixed(1) + 'Mb)';
					} else {
						$scope.link.bandwidth = '';
					}
				}

				if ($scope.currentObject.up) {
					if (dataObject.externalIP !== '0.0.0.0') {
						$scope.currentObject.externalIP = dataObject.externalIP;
						$scope.currentObject.location = dataObject.location;
					}
					var currentPopNode = _.findWhere(treeData, { id: 'pop' + dataObject.popId });
					if (currentPopNode.name === DEFAULT_POP_NAME && pops[dataObject.popId] && pops[dataObject.popId].name) {
						currentPopNode.name = pops[dataObject.popId].name;
					}
					$scope.currentObject.pop = currentPopNode;

					if (typeof dataObject.uptime === 'number') {
						$scope.currentObject.uptime = moment.duration(dataObject.uptime).humanize();
					} else {
						//console.log(dataObject.uptime);
					}
				}
			}

			function updateInnerItemScroll() {
				$timeout(function() {
					$scope.$root.updateScroll('#inner-item');
				}, 1, false);
			}

			function selectNode(dataObject) {
				dataObject.color = ONLINE_COLOR;
				updateCurrentNode(dataObject, true);

				if (timeouts.realtimeDataTimeout) {
					$timeout.cancel(timeouts.realtimeDataTimeout);
				}
				if (timeouts.realtimeExtendedTimeout) {
					$timeout.cancel(timeouts.realtimeExtendedTimeout);
				}

				/* if(document.getElementById(node.id)){
				 document.getElementById(node.id).style.display = 'block';
				 }*/

				$scope.rtChartData.fulldata = [];
				$scope.rtChartData.olddata = [];
				$scope.hosts = [];

				if (dataObject.logins) {
					$scope.refreshLogins = new Date().getTime();
				} else {
					$scope.loaders.traffic = true;
					$scope.loaders.links = true;
					$scope.loaders.apps = true;
					getEntityConnectionStats(dataObject.pid, dataObject.type, dataObject.deviceIds, dataObject.name);
					getAppsData(dataObject.pid, $scope.accountChartData.from, $scope.accountChartData.to, dataObject.type);
					updateInnerItemScroll();
				}
			}

			function unSelectNode(dataObject) {
				dataObject.color = '';
				$scope.currentObject = account;
				$scope.currentObject.data.uniqueIdentifier = 'account_' + account.id;  // for editor
				$scope.currentObject.throughput = getAccountThroughput();

				/* if(document.getElementById(node.id)) {
				 document.getElementById(node.id).style.display = 'none';
				 }*/

				$scope.accountChartData.filtereddata = [];
				appsPieChart.dataProvider = $scope.accountChartData.appsdata;
				if ($scope.accountChartData.appsdata.length === 1 && $scope.accountChartData.appsdata[0].name === emptyData.name && $scope.accountChartData.appsdata[0].size === emptyData.size) {
					$('#apps-mini-pie').css('opacity', 0.3);
				} else {
					$('#apps-mini-pie').css('opacity', 1);
				}

				appsPieChart.validateData();
				clearThroughputGraph();
				updateInnerItemScroll();
			}

			function drawX(adj) {
				var ctx = rgraph.canvas.getCtx();
				var pos = adj.nodeFrom.pos.getc(true);
				var pos2 = adj.nodeTo.pos.getc(true);
				ctx.save();
				var dim = 3;
				ctx.translate((pos.x + pos2.x) / 2, (pos.y + pos2.y) / 2);
				ctx.drawImage(icons.down.img, -2.5 * dim, -2.5 * dim, 5 * dim, 5 * dim);
				ctx.restore();
			}

			function drawAlternativeWan(node, online) {
				var ctx = rgraph.canvas.getCtx();
				ctx.save();
				var factor = node.pos.theta < Math.PI ? 45 : 40;
				var nodePolarPos = new $jit.Polar(node.pos.theta, node.pos.rho - factor);
				var newPos = nodePolarPos.toComplex();
				ctx.translate(newPos.x, newPos.y);

				ctx.drawImage(online ? (node.data.up ? icons.alternativeWanConnected.img : icons.alternativeWanConnectedButCatoDisconnected.img) : icons.alternativeWan.img,
					-10, -10, 17, 17);

				ctx.restore();
			}

			function drawS2S(node, online) {
				var ctx = rgraph.canvas.getCtx();
				ctx.save();
				var factor = node.pos.theta < Math.PI ? 75 : 70;
				var nodePolarPos = new $jit.Polar(node.pos.theta, node.pos.rho - factor);
				var newPos = nodePolarPos.toComplex();
				ctx.translate(newPos.x, newPos.y);

				ctx.drawImage(online ? icons.s2sConnected.img : icons.s2s.img,
					-10, -10, 17, 17);

				ctx.restore();
			}

			function drawDataPoint(adj) {
				var ctx = rgraph.canvas.getCtx();
				var pos = adj.nodeFrom.pos.getc(true);
				var pos2 = adj.nodeTo.pos.getc(true);
				ctx.globalCompositeOperation = 'destination-over';
				ctx.save();
				var dim = 4;
				ctx.beginPath();
				ctx.arc((pos.x + pos2.x) / 2, (pos.y + pos2.y) / 2, dim, 0, Math.PI * 2, true);
				ctx.fillStyle = adj.data.$color;
				ctx.fill();

				adj.point = {
					left: ((pos.x + pos2.x) / 2) - dim,
					right: ((pos.x + pos2.x) / 2) + dim,
					top: ((pos.y + pos2.y) / 2) - dim,
					bottom: ((pos.y + pos2.y) / 2) + dim,
				};
				ctx.restore();
				ctx.globalCompositeOperation = 'source-over';
			}

			function drawCircle(alternative, image) {
				var ctx = rgraph.canvas.getCtx();
				ctx.save();
				ctx.translate(0, 0);

				ctx.beginPath();

				var centerX = 0;
				var centerY = 0;
				if (alternative) {
					var height = 57;
					var width = 59;
					ctx.moveTo(centerX, centerY - height / 2); // A1
					ctx.bezierCurveTo(
						centerX + width / 2, centerY - height / 2, // C1
						centerX + width / 2, centerY + height / 2, // C2
						centerX, centerY + height / 2); // A2

					ctx.bezierCurveTo(
						centerX - width / 2, centerY + height / 2, // C3
						centerX - width / 2, centerY - height / 2, // C4
						centerX, centerY - height / 2); // A1

					ctx.fillStyle = 'white';
					ctx.fill();
					ctx.closePath();
				}

				ctx.moveTo(0, 0);

				if (alternative) {
					ctx.drawImage(image, -30, -29, 59, 57);
				} else {
					ctx.drawImage(image, -115, -115, 230, 230);
				}

				ctx.restore();
				ctx.globalCompositeOperation = 'source-over';
			}


			function refreshNodes(data, hideOverlay) {
				if (!$scope.loaded) {
					return;
				}
				if (!rgraph || !implemented) {
					timeouts.refreshNodesTimeout = $timeout(function () {
						refreshNodes(data, true);
					}, 10, false);
					return;
				}

				rgraph.loadJSON(data);
				if (rgraph.canvas.getElement().style.cursor !== 'pointer' && rgraph.canvas.getElement().style.cursor !== 'crosshair') {
					rgraph.canvas.getElement().style.cursor = 'move';
				}

				rgraph.refresh();

				if (hideOverlay) {
					hideLoader(true);
				}
			}


			function getAccountThroughput() {
				return _.sum(treeData[0].data.members);
			}

			function showLoader() {
				$('#loading-wrapper').css({
					display: 'block',
					opacity: 1,
				});
			}

			function hideLoader(fadeOut) {
				if (fadeOut) {
					$('#loading-wrapper').fadeOut();
				} else {
					$('#loading-wrapper').css('display', 'none');
				}
			}


			function getEnabledBladesCount() {
				return ($scope.accountDetails.accessRulesEnabled | 0) + ($scope.accountDetails.appRulesEnabled | 0) + ((!$scope.$root.useNewFW && $scope.accountDetails.urlFilteringEnabled) | 0) + ($scope.accountDetails.avConfigurationEnabled | 0) + ($scope.accountDetails.ngAvConfigurationEnabled | 0) + ($scope.accountDetails.ipsConfigurationEnabled | 0);
			}

			function isAltWanInterface(interfaceType) {
			    if(interfaceType === "ALTERNATIVE" || interfaceType === "LAYER_2_WAN") {
			        return true;
			    }
			    return false;
			}

			$scope.$on('$destroy', function () {
				$scope.loaded = false;
				$(window).off('resize', windowResize);
				$('body').off('click', checkDropdowns);
				$(document).off('keydown', openSearchSites);
				$('#bladedModifedDlg').off();
				if (handleVisibilityChange) {
					document.removeEventListener("visibilitychange", handleVisibilityChange, false);
				}
				hideLoader();

				for (var timeoutTemp in timeouts) {
					if (timeouts[timeoutTemp]) {
						$timeout.cancel(timeouts[timeoutTemp]);
					}
				}
				IntervalService.cancelDynamicInterval($scope.$id, 'networkTopoGetTopo');
				IntervalService.cancelDynamicInterval($scope.$id, 'networkTopoGetAccountStats');

				$scope.$root.hideNotification();
			});
		},
	};
}]);
